<template>
<div class="mct-public-application" v-once>
<div id="layout-wrapper">
    <div class="main-content ms-0">
        <div class="page-content">
            <div class="container-fluid">
                <!-- start page title -->
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-10">
                        <div class="mct-custom-topbar">
                            <p class="mct-custom-topbar-title mb-0"><i class="ri-file-list-3-line align-middle me-2"></i>MCT Online - Application Membership</p>
                            <img :src="logoSrc" alt="MCT Logo">
                        </div>
                    </div>
                </div>

                <!-- end page title -->
                <div v-if="flashMessage && !captchaBlockMessage" class="row justify-content-center">
                    <div class="col-12 col-xl-10">
                        <div class="alert alert-dismissible fade show" :class="flashKind === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
                            <i class="align-middle me-1" :class="flashKind === 'success' ? 'ri-checkbox-circle-fill' : 'ri-error-warning-fill'"></i>
                            {{ flashMessage }}
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                    </div>
                </div>
                <div v-if="isSubmittedSuccess" class="row justify-content-center">
                    <div class="col-12 col-xl-10">
                        <div class="alert alert-info" role="alert">
                            <i class="ri-mail-check-line align-middle me-1"></i>
                            ส่งใบสมัครเรียบร้อยแล้ว หากต้องการส่งใบสมัครใหม่ให้รีเฟรชหน้าอีกครั้ง
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-12 col-xl-10">
                        <div class="mct-public-wrap" :class="{ 'd-none': isSubmittedSuccess }">


    <div class="card">
        <div class="card-header bg-info-subtle border-0">
           <h4 class="card-title mb-1 text-white"><i class="ri-file-text-line align-middle me-2"></i>APPLICATION FOR MEMBERSHIP MUSIC COPYRIGHT (THAILAND) LTD.</h4>
            <p class="small text-white-50 mb-0">
                <i class="ri-information-line align-middle me-1"></i>กรุณากรอกข้อมูลให้ครบถ้วนเพื่อใช้สำหรับสมัครสมาชิก
            </p>
           
        </div>
        <div class="card-body">
            <div class="row justify-content-center">
                <div class="col-12 col-xl-12">
                <h4 class="card-title mb-0"><i class="ri-book-open-line align-middle me-2"></i>ให้อ่าน "สัญญาอนุญาตสิทธิประเภททั่วไป (General License) และประเภทดิจิทัล (Digital License)" ก่อนกรอกข้อมูลส่วนบุคคล, ข้อมูลติดต่อ, ที่อยู่, ผลงานเพลง และแนบไฟล์เอกสารใบสมัคร</h4>
                <br>
                <div class="border rounded p-3 bg-light-subtle mct-contract-scroll" id="contract-scroll-box">
                        <div class="small mct-contract-text">
                            <p class="mct-contract-title"><i class="ri-auction-line d-block mb-1 fs-18"></i>สัญญาอนุญาตสิทธิประเภททั่วไป (General License)<br>และประเภทดิจิทัล (Digital License)</p>
                            <p class="mct-contract-lead">ผู้อนุญาตและผู้รับอนุญาตตกลงร่วมกันดังต่อไปนี้</p>

                            <p class="mct-article">1. คำนิยาม</p>
                            <p>ในสัญญานี้ เว้นแต่บริบทเป็นอย่างอื่น ให้คำต่อไปนี้ มีความหมายดังนี้</p>
                            <p class="mct-clause"><span class="mct-num">1.1</span><span>คำว่า <strong>ดนตรีกรรม</strong> หมายถึง งานที่เกี่ยวกับเพลงที่แต่งขึ้นเพื่อบรรเลง หรือขับร้องไม่ว่าจะมีทำนองและคำร้องหรือมีทำนองอย่างเดียว และให้หมายความรวมถึงโน้ตเพลง หรือแผนภูมิเพลงที่ได้แยกและเรียบเรียงเสียงประสานแล้ว และให้หมายความรวมถึงเนื้อร้องที่ไม่มีดนตรีประกอบ ทั้งนี้ไม่ว่าจะบางส่วนหรือว่าทั้งหมดซึ่งเป็นของ หรือถูกควบคุมดูแล จัดการแต่เพียงผู้เดียวโดยผู้อนุญาต</span></p>
                            <p class="mct-clause"><span class="mct-num">1.2</span><span>คำว่า <strong>สิทธิเผยแพร่ต่อสาธารณชน</strong> หมายถึง สิทธิที่จะกระทำการหรือให้ผู้อื่นกระทำการเกี่ยวกับดนตรีกรรมในลักษณะดังนี้</span></p>
                            <ul>
                                <li>ทำให้ปรากฏและหรือเผยแพร่ต่อสาธารณชน โดยการแสดง การบรรยาย การสวด การบรรเลง การทำให้ปรากฏด้วยเสียงและหรือภาพ การจำหน่าย หรือโดยวิธีอื่นใดซึ่งงานที่ได้จัดทำขึ้น</li>
                                <li>เพื่อป้องกันข้อสงสัย หมายความรวมถึงการแสดงต่อสาธารณชน การกระจายเสียงทางวิทยุและ/หรือโทรทัศน์ การส่งสัญญาณภาพและ/หรือเสียง หรือส่งสัญญาณซ้ำ ไม่ว่าจะโดยวิธีการ เครือข่าย หรือเทคโนโลยีใด ๆ ก็ตาม</li>
                            </ul>
                            <p class="mct-clause"><span class="mct-num">1.3</span><span>คำว่า <strong>สิทธิทำซ้ำ</strong> หมายความรวมถึง คัดลอกไม่ว่าโดยวิธีใด ๆ เลียนแบบ ทำสำเนา ทำแม่พิมพ์ บันทึกเสียง บันทึกภาพ หรือบันทึกเสียงและภาพ จากต้นฉบับ จากสำเนา หรือการโฆษณาในส่วนอันเป็นสาระสำคัญ รวมทั้งการทำซ้ำเพื่อประกอบภาพเคลื่อนไหว (Synchronization) ไม่ว่าทั้งหมดหรือแต่บางส่วน ลงสื่อทัศนวัสดุประเภทใด ๆ รวมถึงแต่ไม่จำกัดเฉพาะ รายการโทรทัศน์ ละครโทรทัศน์ ภาพยนตร์ ตัวอย่างภาพยนตร์ งานโฆษณา วีดีโอเกมส์ และเว็บไซต์ หรือโปรแกรมประยุกต์ (Application Program) และให้หมายความรวมถึงการทำสำเนาจากระบบคอมพิวเตอร์ และ/หรือ เครือข่ายอินเทอร์เน็ตลงในอุปกรณ์สื่อสาร อาทิ คอมพิวเตอร์ โทรศัพท์มือถือ หรืออุปกรณ์อื่นใดซึ่งสามารถรับและแสดงผลเสียง และ/หรือภาพโดยเชื่อมต่อผ่านทางสัญญาณ ระบบอินเทอร์เน็ต ระบบไร้สาย หรือเชื่อมต่อผ่านอุปกรณ์อื่น โดยมีวัตถุประสงค์เพื่อเผยแพร่ต่อสาธารณชน</span></p>
                            <p>สิทธิดังกล่าวตามข้อ 1.2 และ 1.3 จะมีอยู่ตราบเท่าที่กฎหมายว่าด้วยลิขสิทธิ์ของประเทศไทยจะอนุญาต และหมายรวมไปถึงสิทธิการเผยแพร่ต่อสาธารณชน และทำซ้ำที่มีอยู่ตามกฎหมายว่าด้วยลิขสิทธิ์ของประเทศอื่น ๆ ด้วย</p>

                            <p class="mct-article">2. การอนุญาตสิทธิ</p>
                            <p>ผู้อนุญาตตกลงอนุญาตให้ผู้รับอนุญาตดูแล ควบคุม ให้อนุญาตการใช้งาน จัดเก็บและจัดสรรค่าสิทธิแต่เพียงผู้เดียว (Exclusive Right) จากผู้ใช้งานทั่วโลก รวมทั้งผู้ใช้งานในประเทศไทย ซึ่งสิทธิดังต่อไปนี้</p>
                            <ul>
                                <li>2.1 สิทธิเผยแพร่ต่อสาธารณชน</li>
                                <li>2.2 สิทธิทำซ้ำ</li>
                            </ul>
                            <p>ในงานดนตรีกรรมทั้งปวงเท่าที่ผู้อนุญาตเป็นเจ้าของ ควบคุม ดูแลจัดการสิทธิแต่เพียงผู้เดียวอยู่ในเวลานี้ หรือจะมีต่อไปในอนาคต และมีอยู่ในทุกประเทศทั่วโลก ไม่ว่าจะเป็นสิทธิที่ผู้อนุญาตได้มา โดยการสร้างสรรค์ดนตรีกรรมเองหรือโดยการรับโอนหรือได้รับอนุญาตให้ใช้สิทธิมาจากผู้อื่น ตลอดระยะเวลาตามสัญญาฉบับนี้ และผู้รับอนุญาตขอรับซึ่งสิทธิดังกล่าวทั้งหมดจากผู้อนุญาต เพื่อถือไว้และใช้ในการเรียกเก็บค่าอนุญาตให้ใช้สิทธิและ/หรืออนุญาตให้สิทธิแก่บุคคลอื่นตราบเท่าที่สิทธิดังกล่าวจะมีอยู่ สิทธิดังกล่าวต่อไปในสัญญานี้เรียกว่า “สิทธิที่อนุญาต”</p>

                            <p class="mct-article">3. การจัดสรรค่าสิทธิ</p>
                            <p>ผู้รับอนุญาตตกลงว่า ผู้รับอนุญาตจะจัดสรรเงินคืนให้ผู้อนุญาต โดยเงินดังกล่าวจะมาจากเงินที่ผู้รับอนุญาตเรียกเก็บค่าอนุญาตให้ใช้สิทธิที่อนุญาต จำนวนเงินที่ผู้อนุญาตจะได้รับนั้นจะขึ้นอยู่กับระบบการจ่ายค่าอนุญาตให้ใช้สิทธิ ตามเอกสารแนบท้ายหมายเลข 1</p>
                            <p>ผู้รับอนุญาตสงวนสิทธิ์ในการแก้ไขกฎการจัดสรรค่าสิทธิ โดยคณะกรรมการของผู้รับอนุญาตจะเป็นผู้กำหนดขึ้นตามข้อบังคับของบริษัท ณ เวลาใด ๆ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า ผู้อนุญาตตกลงผูกพันตามการแก้ไขดังกล่าว</p>

                            <p class="mct-article">4. การรับรองสิทธิ</p>
                            <p class="mct-clause"><span class="mct-num">4.1</span><span>ผู้อนุญาตขอรับรองต่อผู้รับอนุญาตว่า ผู้อนุญาตมีลิขสิทธิ์ หรือได้รับโอนสิทธิหรือได้รับอนุญาตให้ใช้สิทธิในดนตรีกรรมในส่วนของสิทธิที่อนุญาตโดยสมบูรณ์ และผู้อนุญาตสามารถอนุญาตลิขสิทธิ์ในดนตรีกรรมในส่วนดังกล่าวได้ตามกฎหมาย</span></p>
                            <p class="mct-clause"><span class="mct-num">4.2</span><span>ผู้อนุญาตขอรับรองด้วยว่าไม่มีดนตรีกรรมใด ๆ ของผู้อนุญาตที่ละเมิดลิขสิทธิ์ในงานใด ๆ ของผู้อื่นไม่ว่าจะทั้งหมดหรือบางส่วน และผู้อนุญาตจะกระทำการใด ๆ ก็ตาม เพื่อไม่ให้ผู้รับอนุญาตต้องได้รับความเสียหายหรือถูกฟ้องร้องดำเนินคดี และขอรับผิดชอบในค่าเสียหาย หรือค่าใช้จ่ายใด ๆ ที่บุคคลภายนอกอาจจะเรียกร้องเอาจากผู้รับอนุญาต อันเนื่องมาจากการที่ผู้รับอนุญาตใช้สิทธิที่อนุญาต</span></p>
                            <p class="mct-clause"><span class="mct-num">4.3</span><span>ผู้อนุญาตตกลงว่า ผู้อนุญาตจะไม่มอบสิทธิในลักษณะเดียวกันตามสัญญานี้ให้กับผู้อื่นอีก (Exclusive Right) ในระหว่างที่สัญญายังคงมีผลบังคับใช้</span></p>
                            <p class="mct-clause"><span class="mct-num">4.4</span><span>ผู้อนุญาตตกลงรับผิดต่อผู้รับอนุญาตในการเรียกร้อง การต่อสู้คดี ความเสียหาย และค่าใช้จ่ายใด ๆ อันเป็นผลโดยตรง หรือโดยอ้อมจากการที่ผู้อนุญาตละเมิด หรือผิดข้อตกลง หรือคำรับรองใด ๆ ที่ระบุในสัญญานี้</span></p>

                            <p class="mct-article">5. การแจ้งข้อมูล</p>
                            <p>ผู้อนุญาตรับรองว่าจะแจ้งให้ผู้รับอนุญาตทราบในทันทีเกี่ยวกับกรณีดังต่อไปนี้</p>
                            <p class="mct-clause"><span class="mct-num">5.1</span><span>กรณีที่ผู้อนุญาตเปลี่ยนที่อยู่ที่ใช้ในการติดต่อ ทั้งนี้เพื่อประโยชน์ในการบริหารงานของผู้รับอนุญาต</span></p>
                            <p class="mct-clause"><span class="mct-num">5.2</span><span>กรณีที่มีการเพิ่มเติมหรือคัดออกซึ่งดนตรีกรรมภายใต้สัญญานี้ หรือมีการเปลี่ยนแปลงความเป็นเจ้าของลิขสิทธิ์ส่วนอื่น หรือเปลี่ยนแปลงรายละเอียดที่สำคัญใด ๆ ในดนตรีกรรมภายใต้สัญญานี้</span></p>

                            <p class="mct-article">6. ระยะเวลาของสัญญา และการบอกเลิกสัญญา</p>
                            <p class="mct-clause"><span class="mct-num">6.1</span><span>สัญญานี้มีผลบังคับนับแต่วันที่ ................................. เป็นต้นไป</span></p>
                            <p class="mct-clause"><span class="mct-num">6.2</span><span>คู่สัญญาฝ่ายใดฝ่ายหนึ่งมีสิทธิบอกเลิกสัญญานี้ได้ โดยการส่งหนังสือบอกกล่าวเป็นลายลักษณ์อักษรแก่คู่สัญญาอีกฝ่ายหนึ่งล่วงหน้าเป็นระยะเวลาไม่น้อยกว่า 3 เดือน</span></p>
                            <p class="mct-clause"><span class="mct-num">6.3</span><span>ในกรณีที่คู่สัญญาฝ่ายใดฝ่ายหนึ่งละเมิด หรือไม่ปฏิบัติตามสัญญา และไม่สามารถแก้ไขให้เป็นไปตามสัญญาได้ภายในระยะเวลา 30 วัน หลังจากวันที่ได้รับหนังสือแจ้งให้ดำเนินการแก้ไขให้เป็นไปตามสัญญาแล้ว ให้คู่สัญญาอีกฝ่ายหนึ่งมีสิทธิบอกเลิกสัญญาได้ทันที</span></p>
                            <p class="mct-clause"><span class="mct-num">6.4</span><span>เมื่อสัญญาได้สิ้นสุดลง คู่สัญญาตกลงร่วมกันว่า ให้การอนุญาตลิขสิทธิ์ใด ๆ ที่ได้กระทำโดยสุจริต ก่อนการสิ้นสุดของสัญญานี้ ยังคงมีผลบังคับได้ต่อไป แต่ไม่เกิน 12 เดือนนับจากวันสิ้นสุดของสัญญา เว้นแต่คู่สัญญาทั้งสองฝ่ายตกลงเป็นอย่างอื่นเป็นลายลักษณ์อักษร ผู้รับอนุญาตยังคงมีภาระผูกพันในการชำระค่าสิทธิที่เหลืออยู่จากการบริหารสิทธิตามสัญญานี้ให้แก่ผู้อนุญาตจนครบถ้วน</span></p>

                            <p class="mct-article">7. การดำเนินการทางกฎหมาย</p>
                            <p>เพื่อประกอบกับสิทธิที่ได้มอบให้แก่ผู้รับอนุญาต ผู้อนุญาตในที่นี้ขอมอบอำนาจให้ผู้รับอนุญาต และ/หรือตัวแทนของผู้รับอนุญาตเพื่อกระทำการดังต่อไปนี้</p>
                            <p class="mct-clause"><span class="mct-num">7.1</span><span>สาบานในคำให้การเป็นลายลักษณ์อักษร ส่งเสริม กระทำการ หรือฟ้องร้องดำเนินคดีในคดีแพ่งหรืออาญา ยื่นคำร้องทุกข์ หนังสือแจ้ง หรือยื่นหลักฐานต่อศาล คณะไต่สวน หรือต่อผู้มีอำนาจหน้าที่ที่เกี่ยวข้อง และแต่งตั้งทนายเพื่อดำเนินการหรือฟ้องร้องดำเนินคดีทั้งคดีแพ่งหรืออาญาในนามของผู้อนุญาต ในกรณีที่มีการละเมิดลิขสิทธิ์ในงานของผู้อนุญาต และในกรณีที่มีข้อขัดแย้งที่สืบเนื่องจากการบริหารสิทธิในสัญญานี้</span></p>
                            <p class="mct-clause"><span class="mct-num">7.2</span><span>ประนีประนอมยอมความในกรณีที่มีการชี้ขาดโดยอนุญาโตตุลาการหรือศาล หรือทำให้คดีความใด ๆ ลุล่วงไปตามสิทธิที่ได้รับจากสัญญานี้ และปรึกษาตามแต่จะเห็นสมควรกับเจ้าของลิขสิทธิ์หรือผู้รับอนุญาตตามความเหมาะสม</span></p>
                            <p class="mct-clause"><span class="mct-num">7.3</span><span>รับทรัพย์สิน ค่าเสียหาย หรือค่าใช้จ่ายใด ๆ ที่เกิดจากการชี้ขาดโดยอนุญาโตตุลาการ คำตัดสินของศาล คณะไต่สวน หรือผู้มีอำนาจหน้าที่ที่เกี่ยวข้อง หรือตามข้อตกลงจะชำระหนี้ในคดีที่สืบเนื่องจากการบริหารสิทธิในสัญญานี้</span></p>

                            <p class="mct-article">8. การเก็บรักษาความลับ</p>
                            <p>คู่สัญญาทั้งสองฝ่ายตกลงจะเก็บรายละเอียดการอนุญาตสิทธิตามสัญญานี้ไว้เป็นความลับ ซึ่งรวมถึงแต่ไม่จำกัดเพียงรายละเอียดการจ่ายเงินของผู้รับอนุญาต เป็นต้น และตกลงจะใช้มาตรการใด ๆ ที่เหมาะสม เพื่อรักษาไว้ซึ่งความลับของการอนุญาตสิทธิตามสัญญานี้ ในระดับที่เท่ากันกับการปกป้องข้อมูลของตนเอง โดยจะไม่เปิดเผยแก่บุคคลภายนอกไม่ว่าทั้งหมดหรือแต่บางส่วน เว้นแต่จะได้รับอนุญาตเป็นลายลักษณ์อักษรจากคู่สัญญาอีกฝ่ายหนึ่ง</p>

                            <p class="mct-article">9. ทั่วไป</p>
                            <p class="mct-clause"><span class="mct-num">9.1</span><span>สัญญาฉบับนี้ ให้ถือว่าอยู่ภายใต้บังคับของกฎหมายแห่งราชอาณาจักรไทย ในกรณีที่มีข้อพิพาทระหว่างกันเกิดขึ้น คู่สัญญาทั้งสองฝ่ายตกลงที่จะนำคดีขึ้นสู่การพิจารณาของศาลทรัพย์สินทางปัญญาและการค้าระหว่างประเทศกลาง</span></p>
                            <p>ทั้งสองฝ่ายได้อ่านและเข้าใจข้อความโดยตลอดแล้ว เพื่อเป็นพยานหลักฐานแห่งการนี้ คู่สัญญาทั้งสองฝ่ายได้ลงลายมือชื่อ และประทับตราสำคัญไว้ต่อหน้าพยาน ในวันที่ระบุข้างต้น</p>

                            <hr class="mct-contract-divider">
                            <p class="mct-annex-kicker"><i class="ri-attachment-line align-middle me-1"></i>เอกสารแนบท้ายหมายเลข 1</p>
                            <p class="mct-annex-title">การจัดสรรค่าสิทธิประเภททั่วไป (General License)</p>
                            <p>ผู้อนุญาตตกลงให้ผู้รับอนุญาตหักค่าใช้จ่ายตามจริงในอัตราไม่เกินร้อยละ 20 (ยี่สิบ) จากเงินที่ได้รับมาจากการจัดเก็บหลังหักค่าใช้จ่ายของหน่วยจัดเก็บแล้ว (บริษัท เอ็มพีซี มิวสิค จำกัด)</p>
                            <p class="mct-annex-title">การจัดสรรค่าสิทธิประเภทดิจิทัล (Digital License)</p>
                            <p>ผู้อนุญาตตกลงให้ผู้รับอนุญาตหักค่าใช้จ่ายตามจริงในอัตราไม่เกินร้อยละ 12 (สิบสอง) จากเงินที่ได้รับมาจากการจัดเก็บโดยตรง</p>
                            <p class="mct-annex-title">วิธีการ และระยะเวลา</p>
                            <p class="mb-0">โดยวิธีการ และระยะเวลาจัดสรรเงินจะเป็นไปตาม ระเบียบการจัดสรรค่าสิทธิ (Distribution Rule) และผู้รับอนุญาตอาจแก้ไขได้เป็นครั้งคราวไปโดยมิต้องได้รับความยินยอมจากผู้อนุญาต</p>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            <br>
            <div class="row justify-content-center mb-3">
                    <div class="col-12 col-xl-">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="1" id="accept-contract" name="accept_contract" form="form-member-add" required disabled>
                            <label class="form-check-label" for="accept-contract">
                                <i class="ri-checkbox-circle-line align-middle me-1"></i>ข้าพเจ้ายอมรับสัญญาอนุญาตสิทธิประเภททั่วไป (General License) และประเภทดิจิทัล (Digital License) <span class="text-danger">*</span>
                            </label>
                            <small id="accept-contract-hint" class="text-muted d-block"><i class="ri-arrow-down-double-line align-middle me-1"></i>กรุณาเลื่อนอ่านข้อความสัญญาให้สุดก่อน จึงจะสามารถติ๊กยอมรับได้</small>
                            <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none" id="accept-contract-req-hint">จำเป็นต้องกรอก</small>
                        </div>
                    </div>
            </div>
        </div>
    </div>

    <form id="form-member-add" method="post" :action="createUrl" enctype="multipart/form-data" autocomplete="off" novalidate>
        <div id="mct-form-submit-inline-msg" class="alert alert-danger py-2 px-3 small mb-3 d-none" role="alert"></div>
        <div class="card mct-gated-section">
            <div class="card-header bg-primary text-white border-0 d-flex flex-wrap align-items-center justify-content-between gap-2">
                <h4 class="card-title mb-0 text-white"><i class="ri-user-3-line align-middle me-2"></i>ข้อมูลส่วนบุคคล</h4>
                <span class="small text-white-50"><span class="text-warning">*</span> <span class="text-danger fw-bold mct-req-hint mct-req-hint-legend d-none">จำเป็นต้องกรอก</span></span>
            </div>
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-12">
                <div class="row g-3">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="prefix" class="form-label">คำนำหน้า <span class="text-danger">*</span></label>
                        <select class="form-select" id="prefix" name="prefix" required>
                            <option value="">— เลือก —</option>
                            <option value="นาย">นาย</option>
                            <option value="นาง">นาง</option>
                            <option value="นางสาว">นางสาว</option>
                            <option value="อื่นๆ">อื่น ๆ</option>
                        </select>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                        <input type="text" class="form-control mt-2 d-none" id="prefix_other" name="prefix_other" maxlength="50" placeholder="ระบุคำนำหน้า" autocomplete="off">
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="nationality" class="form-label">สัญชาติ <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="nationality" name="nationality" placeholder="เช่น ไทย" required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <label class="form-label">ประเภทเอกสารแสดงตน <span class="text-danger">*</span></label>
                        <div class="d-flex flex-wrap gap-3 pt-1">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="id_document_type" id="id-document-type-id-card" value="id_card" checked>
                                <label class="form-check-label" for="id-document-type-id-card">บัตรประชาชน</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="id_document_type" id="id-document-type-passport" value="passport">
                                <label class="form-check-label" for="id-document-type-passport">พาสปอร์ต</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="id_card" class="form-label" id="id-card-label">เลขบัตรประชาชน (13 หลัก) <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="id_card" name="id_card" inputmode="numeric" pattern="[0-9]{13}" minlength="13" maxlength="13" placeholder="เช่น 1103700000000" required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                        <small class="form-text mb-0 text-danger fw-bold d-none" id="id-card-duplicate-hint" role="status"></small>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="birth_date" class="form-label">วันเดือนปีเกิด <span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input type="text" class="form-control" id="birth_date" name="birth_date" inputmode="numeric" pattern="\d{2}/\d{2}/\d{4}" maxlength="10" placeholder="dd/mm/yyyy" required>
                            <button class="btn btn-soft-secondary" type="button" id="btn-birth-date-picker" aria-label="เลือกวันเดือนปีเกิดจากปฏิทิน">
                                <i class="ri-calendar-line"></i>
                            </button>
                        </div>
                        <small class="form-text text-muted">พิมพ์รูปแบบ dd/mm/yyyy หรือเลือกจากปฏิทิน</small>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="w-100 d-none d-lg-block"></div>
                    <div class="col-lg-3 col-md-6 mt-n2">
                        <label for="first_name" class="form-label">ชื่อ <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="first_name" name="first_name" placeholder="กรอกชื่อ" required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-3 col-md-6 mt-n2">
                        <label for="last_name" class="form-label">นามสกุล <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="last_name" name="last_name" placeholder="กรอกนามสกุล" required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-3 col-md-6 mt-n2">
                        <label for="first_name_en" class="form-label">ชื่อ (English) <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="first_name_en" name="first_name_en" placeholder="First name" required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-3 col-md-6 mt-n2">
                        <label for="last_name_en" class="form-label">นามสกุล (English) <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="last_name_en" name="last_name_en" placeholder="Last name" required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="old_name" class="form-label">ชื่อ-สกุลเดิม (ในกรณีมีการเปลี่ยนชื่อ)</label>
                        <input type="text" class="form-control" id="old_name" name="old_name" placeholder="กรอกชื่อ-สกุลเดิม">
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="name_change_document" class="form-label">เอกสารยืนยันการเปลี่ยนชื่อ</label>
                        <input type="file" class="form-control" id="name_change_document" name="name_change_document" accept=".pdf,.jpg,.jpeg,.png" disabled>
                        <small class="form-text text-muted">รองรับ PDF, JPG, PNG (เปิดใช้เมื่อกรอกชื่อเดิม ต้องแนบเอกสาร)</small>
                        <small class="form-text mb-0 text-danger fw-bold d-none" id="name-change-doc-hint">กรุณาแนบเอกสารยืนยันการเปลี่ยนชื่อ</small>
                    </div>
                    <div class="col-12">
                        <label class="form-label mb-2">ประเภทผู้สร้างสรรค์เพลง <span class="text-danger">*</span></label>
                        <div class="border rounded p-3 bg-light">
                            <div class="form-check mb-2">
                                <input class="form-check-input mct-creative-role" type="checkbox" id="creative-role-composer" name="creative_roles[]" value="composer" required>
                                <label class="form-check-label" for="creative-role-composer">ผู้ประพันธ์ทำนอง</label>
                            </div>
                            <div class="form-check mb-2">
                                <input class="form-check-input mct-creative-role" type="checkbox" id="creative-role-author" name="creative_roles[]" value="author">
                                <label class="form-check-label" for="creative-role-author">ผู้ประพันธ์เนื้อร้อง</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input mct-creative-role" type="checkbox" id="creative-role-arranger" name="creative_roles[]" value="arranger">
                                <label class="form-check-label" for="creative-role-arranger">ผู้เรียบเรียงเสียงประสาน</label>
                            </div>
                        </div>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="form-label mb-0">นามปากกา</label>
                            <button type="button" class="btn btn-sm btn-soft-primary" id="btn-add-pen-name"><i class="ri-add-line align-middle"></i> เพิ่มนามปากกา</button>
                        </div>
                        <div id="pen-name-rows">
                            <div class="input-group mb-2 pen-name-row">
                                <input type="text" class="form-control mct-pen-name-item" name="pen_names[]" placeholder="กรอกนามปากกา">
                                <button type="button" class="btn btn-soft-danger pen-name-remove" title="ลบรายการ"><i class="ri-delete-bin-line align-middle"></i> ลบ</button>
                            </div>
                        </div>
                        <input type="hidden" id="pen_name" name="pen_name" value="">
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mct-gated-section">
            <div class="card-header bg-primary text-white border-0">
                <h4 class="card-title mb-0 text-white"><i class="ri-contacts-line align-middle me-2"></i>ข้อมูลติดต่อ</h4>
            </div>
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-12">
                <div class="row g-3">
                    <div class="col-lg-6">
                        <label for="email" class="form-label">อีเมล <span class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="email" name="email" maxlength="255" required placeholder="name@example.com" autocomplete="email">
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                        <small class="form-text mb-0 text-danger fw-bold d-none" id="email-duplicate-hint" role="status"></small>
                    </div>
                    <div class="col-lg-6">
                        <label for="phone" class="form-label">เบอร์โทรศัพท์ <span class="text-danger">*</span></label>
                        <input type="tel" class="form-control mct-phone-mobile" id="phone" name="phone" maxlength="12" required inputmode="numeric" pattern="[0-9 ]*" placeholder="000 000 0000" autocomplete="tel-national" title="มือถือไทย 10 หลัก ตัวเลขเท่านั้น">
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                        <small class="form-text mb-0 text-danger fw-bold d-none" id="phone-duplicate-hint" role="status"></small>
                    </div>
                    <div class="col-lg-6">
                        <label for="line_id" class="form-label">Line ID</label>
                        <input type="text" class="form-control" id="line_id" name="line_id" placeholder="เช่น lineid1234">
                    </div>
                    <div class="col-lg-6">
                        <label for="facebook" class="form-label">Facebook / Social</label>
                        <input type="text" class="form-control" id="facebook" name="facebook" placeholder="เช่น facebook.com/yourprofile">
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mct-gated-section">
            <div class="card-header bg-primary text-white border-0">
                <h4 class="card-title mb-0 text-white"><i class="ri-map-pin-line align-middle me-2"></i>ที่อยู่</h4>
            </div>
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-12">
                <div class="row g-3">
                    <div class="col-12">
                        <label for="address" class="form-label">รายละเอียดที่อยู่ <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="address" name="address_street" maxlength="510" required autocomplete="street-address" placeholder="เลขที่ หมู่บ้าน อาคาร ห้อง / หมู่ที่ ซอย ถนน">
                        <input type="hidden" name="address_type" value="ที่อยู่ตามทะเบียน">
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                        <small class="text-muted d-block">รวมข้อมูลเลขที่-อาคาร กับ หมู่ที่-ซอย-ถนนในช่องเดียว</small>
                    </div>
                    <div class="col-12">
                        <label for="address-live-search" class="form-label">ค้นหาที่อยู่จากฐานข้อมูล</label>
                        <div class="position-relative">
                            <input type="text" class="form-control" id="address-live-search" autocomplete="off" placeholder="พิมพ์ ตำบล อำเภอ จังหวัด หรือรหัสไปรษณีย์ (อย่างน้อย 2 ตัวอักษร)" aria-autocomplete="list" aria-controls="address-live-search-dropdown">
                            <div id="address-live-search-dropdown" class="list-group position-absolute w-100 mt-1 shadow-sm border rounded" role="listbox" style="z-index:1050;max-height:260px;overflow-y:auto;display:none;top:100%;left:0;"></div>
                        </div>
                        <div id="address-live-search-status" class="text-muted small mt-1"></div>
                        <div id="address-live-search-error" class="text-danger small mt-1" style="display:none;"></div>
                        <small class="text-muted d-block mt-1">เลือกรายการเพื่อกรอกตำบล อำเภอ จังหวัด และรหัสไปรษณีย์</small>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <label for="address-subdistrict" class="form-label">ตำบล / แขวง <span class="text-danger">*</span></label>
                        <input type="text" class="form-control bg-light" id="address-subdistrict" name="address_subdistrict" maxlength="120" required readonly placeholder="เลือกจากการค้นหาด้านบน" title="เลือกจากการค้นหาด้านบน">
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <label for="district" class="form-label">อำเภอ / เขต <span class="text-danger">*</span></label>
                        <input type="text" class="form-control bg-light" id="address-district" name="address_district" maxlength="120" required readonly placeholder="เลือกจากการค้นหาด้านบน" title="เลือกจากการค้นหาด้านบน">
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <label for="province" class="form-label">จังหวัด <span class="text-danger">*</span></label>
                        <input type="text" class="form-control bg-light" id="address-province" name="address_province" maxlength="120" required readonly placeholder="เลือกจากการค้นหาด้านบน" title="เลือกจากการค้นหาด้านบน">
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <label for="zipcode" class="form-label">รหัสไปรษณีย์ <span class="text-danger">*</span></label>
                        <input type="text" class="form-control bg-light" id="address-postal-code" name="address_postal_code" maxlength="10" required inputmode="numeric" pattern="[0-9]{1,10}" placeholder="เลือกจากการค้นหาด้านบน (เช่น 10330)" readonly title="เลือกจากการค้นหาด้านบน">
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-12">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="1" id="mailing-same-as-id" name="mailing_same_as_id" checked>
                            <label class="form-check-label" for="mailing-same-as-id">ใช้ที่อยู่ตามทะเบียนเป็นที่อยู่จัดส่งเอกสาร</label>
                        </div>
                    </div>
                    <div id="mailing-address-fields" class="col-12 d-none">
                        <div class="border rounded p-3 bg-light-subtle">
                            <p class="fw-semibold mb-3">ที่อยู่จัดส่งเอกสาร</p>
                            <div class="row g-3">
                                <div class="col-12">
                                    <label for="mailing_street" class="form-label">รายละเอียดที่อยู่ <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" id="mailing_street" name="mailing_street" maxlength="510" placeholder="เลขที่ หมู่บ้าน อาคาร ห้อง / หมู่ที่ ซอย ถนน">
                                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                                </div>
                                <div class="col-12">
                                    <label for="mailing-live-search" class="form-label">ค้นหาที่อยู่จากฐานข้อมูล</label>
                                    <div class="position-relative">
                                        <input type="text" class="form-control" id="mailing-live-search" autocomplete="off" placeholder="พิมพ์ ตำบล อำเภอ จังหวัด หรือรหัสไปรษณีย์ (อย่างน้อย 2 ตัวอักษร)">
                                        <div id="mailing-live-search-dropdown" class="list-group position-absolute w-100 mt-1 shadow-sm border rounded" role="listbox" style="z-index:1050;max-height:260px;overflow-y:auto;display:none;top:100%;left:0;"></div>
                                    </div>
                                    <div id="mailing-live-search-status" class="text-muted small mt-1"></div>
                                    <div id="mailing-live-search-error" class="text-danger small mt-1" style="display:none;"></div>
                                </div>
                                <div class="col-lg-3 col-md-6">
                                    <label for="mailing-subdistrict" class="form-label">ตำบล / แขวง <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control bg-light" id="mailing-subdistrict" name="mailing_subdistrict" maxlength="120" readonly placeholder="เลือกจากการค้นหาด้านบน">
                                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                                </div>
                                <div class="col-lg-3 col-md-6">
                                    <label for="mailing-district" class="form-label">อำเภอ / เขต <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control bg-light" id="mailing-district" name="mailing_district" maxlength="120" readonly placeholder="เลือกจากการค้นหาด้านบน">
                                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                                </div>
                                <div class="col-lg-3 col-md-6">
                                    <label for="mailing-province" class="form-label">จังหวัด <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control bg-light" id="mailing-province" name="mailing_province" maxlength="120" readonly placeholder="เลือกจากการค้นหาด้านบน">
                                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                                </div>
                                <div class="col-lg-3 col-md-6">
                                    <label for="mailing-postal-code" class="form-label">รหัสไปรษณีย์ <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control bg-light" id="mailing-postal-code" name="mailing_postal_code" maxlength="10" readonly placeholder="เลือกจากการค้นหาด้านบน">
                                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mct-gated-section">
            <div class="card-header bg-primary text-white border-0">
                <h4 class="card-title mb-0 text-white"><i class="ri-music-2-line align-middle me-2"></i>ผลงานเพลง</h4>
            </div>
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-12">
                <div class="row g-3">
                    <div class="col-lg-6">
                        <label for="song_title" class="form-label">ชื่อเพลง <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="song_title" name="song_title" placeholder="กรอกชื่อเพลง" required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="song_artist" class="form-label">ศิลปิน <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="song_artist" name="song_artist" placeholder="กรอกชื่อศิลปิน" required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="song_album" class="form-label">อัลบั้ม</label>
                        <input type="text" class="form-control" id="song_album" name="song_album" placeholder="กรอกชื่ออัลบั้ม">
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="song_lyrics_opening" class="form-label">เนื้อร้องขึ้นต้น <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="song_lyrics_opening" name="song_lyrics_opening" placeholder="ยกตัวอย่างเนื้อร้องช่วงต้นเพลง" required>
                    </div>

                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="form-label mb-0">ผู้แต่งทำนอง <span class="text-danger">*</span></label>
                            <button type="button" class="btn btn-sm btn-soft-primary" id="btn-add-composer"><i class="ri-add-line align-middle"></i> เพิ่มผู้แต่งทำนอง</button>
                        </div>
                        <div id="composer-rows">
                            <div class="input-group mb-2 song-repeat-row">
                                <input type="text" class="form-control" name="song_composer[]" placeholder="ชื่อผู้แต่งทำนอง" required>
                               
                                <button type="button" class="btn btn-soft-danger song-row-remove" title="ลบรายการ"><i class="ri-delete-bin-line align-middle"></i> ลบ</button>
                           
                            </div>
                            
                        </div>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                        
                    </div>

                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="form-label mb-0">ผู้แต่งคำร้อง <span class="text-danger">*</span></label>
                            <button type="button" class="btn btn-sm btn-soft-primary" id="btn-add-lyricist"><i class="ri-add-line align-middle"></i> เพิ่มผู้แต่งคำร้อง</button>
                        </div>
                        <div id="lyricist-rows">
                            <div class="input-group mb-2 song-repeat-row">
                                <input type="text" class="form-control" name="song_lyricist[]" placeholder="ชื่อผู้แต่งคำร้อง" required>
                                <button type="button" class="btn btn-soft-danger song-row-remove" title="ลบรายการ"><i class="ri-delete-bin-line align-middle"></i> ลบ</button>
                            </div>
                        </div>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>

                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="form-label mb-0">ผู้เรียบเรียง </label>
                            <button type="button" class="btn btn-sm btn-soft-primary" id="btn-add-arranger"><i class="ri-add-line align-middle"></i> เพิ่มผู้เรียบเรียง</button>
                        </div>
                        <div id="arranger-rows">
                            <div class="input-group mb-2 song-repeat-row">
                                <input type="text" class="form-control" name="song_arranger[]" placeholder="ชื่อผู้เรียบเรียง">
                                <button type="button" class="btn btn-soft-danger song-row-remove" title="ลบรายการ"><i class="ri-delete-bin-line align-middle"></i> ลบ</button>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <label for="publisher" class="form-label">Publisher (พับลิชเชอร์)</label>
                        
                        <input type="text" class="form-control" id="publisher" name="publisher" placeholder="ชื่อพับลิชเชอร์ (ถ้ามี)">
                        <small class="form-text text-muted d-block mb-1">คำอธิบายเพิ่ม — บริษัทที่ถือสิทธิ์ในผลงานดนตรีกรรม (คำร้อง/ทำนอง)</small>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <label for="song_publish_url" class="form-label">ตัวอย่างการเผยแพร่ URL https://youtube, อื่นๆ <span class="text-danger">*</span></label>
                        <input type="url" class="form-control" id="song_publish_url" name="song_publish_url" placeholder="https://..." required>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mct-gated-section">
            <div class="card-header bg-primary text-white border-0">
                <h4 class="card-title mb-0 text-white"><i class="ri-attachment-2 align-middle me-2"></i>แนบไฟล์เอกสารใบสมัคร</h4>
            </div>
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-12">
                        <div class="row g-3">
                            <div class="col-lg-6">
                                <label for="id_document" class="form-label" id="id-document-file-label">สำเนาบัตรประชาชน <span class="text-danger">*</span></label>
                                <input class="form-control" type="file" id="id_document" name="id_document" accept=".pdf,.jpg,.jpeg,.png" required>
                                <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                            </div>
                            <div class="col-12">
                                <hr class="my-2">
                            </div>
                            <div class="col-lg-6">
                                <label for="bank_name" class="form-label">ธนาคาร <span class="text-danger">*</span></label>
                                <select class="form-select" id="bank_name" name="bank_name" required>
                                    <option value="">— เลือกธนาคาร —</option>
                                    <option v-for="name in bankOptions" :key="name" :value="name">{{ name }}</option>
                                    <option value="อื่นๆ">อื่น ๆ</option>
                                </select>
                                <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                                <input type="text" class="form-control mt-2 d-none" id="bank_name_other" name="bank_name_other" maxlength="150" placeholder="ระบุชื่อธนาคาร">
                            </div>
                            <div class="col-lg-6">
                                <label for="bank_account_holder_name" class="form-label">ชื่อบัญชีธนาคาร <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="bank_account_holder_name" name="bank_account_holder_name" maxlength="200" required placeholder="ชื่อ-นามสกุลตามหน้าสมุดบัญชี">
                                <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                            </div>
                            <div class="col-lg-6">
                                <label for="bank_account_number" class="form-label">เลขที่บัญชีธนาคาร <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="bank_account_number" name="bank_account_number" inputmode="numeric" pattern="[0-9\- ]{6,20}" maxlength="20" placeholder="เช่น 123-4-56789-0" required>
                                <small class="form-text text-muted">กรุณากรอกเฉพาะตัวเลข และ/หรือขีด (ไม่ต้องใส่ช่องว่างถ้าไม่จำเป็น)</small>
                                <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                            </div>
                            <div class="col-lg-6">
                                <label for="bank_book_document" class="form-label">หน้าสมุดบัญชีธนาคาร (หน้าชื่อบัญชี)</label>
                                <input class="form-control" type="file" id="bank_book_document" name="bank_book_document" accept=".pdf,.jpg,.jpeg,.png">
                                <small class="form-text text-muted">แนบไฟล์หน้าสมุดบัญชีที่แสดงชื่อและเลขที่บัญชี รองรับไฟล์ PDF, JPG, PNG (ไม่บังคับ)</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mct-gated-section">
            <div class="card-header bg-primary text-white border-0">
                <h4 class="card-title mb-0 text-white"><i class="ri-pen-nib-line align-middle me-2"></i>ลายเซ็นผู้สมัคร</h4>
            </div>
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-12">
                        <label class="form-label"><i class="ri-pencil-line align-middle me-1"></i>Signature Pad <span class="text-danger">*</span></label>
                        <div class="signature-pad-wrap">
                            <canvas id="signature-pad"></canvas>
                        </div>
                        <input type="hidden" id="signature-data" name="signature_data" value="">
                        <small id="signature-hint" class="form-text mb-0 text-danger fw-bold d-none">จำเป็นต้องกรอก</small>
                        <div class="mt-2 d-flex justify-content-end">
                            <button type="button" class="btn btn-soft-secondary btn-sm" id="btn-signature-clear"><i class="ri-eraser-line align-middle me-1"></i>ล้างลายเซ็น</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mct-gated-section">
            <div class="card-header bg-primary text-white border-0">
                <h4 class="card-title mb-0 text-white"><i class="ri-shield-check-line align-middle me-2"></i>ยินยอมการดำเนินการข้อมูลส่วนบุคคล</h4>
            </div>
            <div class="card-body">
                <div class="vstack gap-2">
                    <div class="form-check mb-0">
                        <input class="form-check-input" type="checkbox" id="consent_personal_data" name="consent_personal_data" required>
                        <label class="form-check-label" for="consent_personal_data">ข้าพเจ้ายินยอมให้ บริษัท ลิขสิทธิ์ดนตรี(ประเทศไทย) จำกัด ดำเนินการเกี่ยวกับข้อมูลส่วนบุคคล <span class="text-danger">*</span></label>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">กรุณายินยอมการดำเนินการข้อมูลส่วนบุคคล</small>
                    </div>
                    <div class="form-check mb-0">
                        <input class="form-check-input" type="checkbox" id="certify_music_rights" name="certify_music_rights" required>
                        <label class="form-check-label" for="certify_music_rights">กรุณารับรองรายละเอียดดนตรีกรรมตามที่แนบมา <span class="text-danger">*</span></label>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">กรุณารับรองรายละเอียดดนตรีกรรมตามที่แนบมา</small>
                    </div>
                    <div class="form-check mb-0">
                        <input class="form-check-input" type="checkbox" id="accept_company_bylaws" name="accept_company_bylaws" required>
                        <label class="form-check-label" for="accept_company_bylaws">ข้าพเจ้าขอรับรองและยินยอมผูกพันตามเงื่อนไขข้อกำหนดในหนังสือบริคณห์สนธิและข้อบังคับบริษัทฯ ที่มีอยู่แล้วในขณะนี้/หรือซึ่งจะแก้ไขเพิ่มเติมต่อภายหน้าด้วย <span class="text-danger">*</span></label>
                        <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">กรุณายืนยันการยอมรับเงื่อนไขข้อกำหนดของบริษัทฯ</small>
                    </div>
                </div>

                <div class="border rounded p-3 bg-light-subtle mb-3 mt-3" id="mct-membership-captcha-block">
                    <div id="mct-membership-captcha-inline-msg" class="alert alert-danger py-2 px-3 small mb-3" :class="{ 'd-none': !captchaBlockMessage }" role="alert">{{ captchaBlockMessage }}</div>
                    <label class="form-label fw-semibold mb-2 d-block" for="membership_captcha"><i class="ri-shield-keyhole-line align-middle me-1"></i>รหัสภาพเพื่อความปลอดภัย <span class="text-danger">*</span></label>
                    <div class="row g-3 align-items-start">
                        <div class="col-12 col-sm-auto">
                            <div class="d-flex flex-wrap align-items-center gap-2">
                                <img alt="รหัสภาพ" id="membership-captcha-img" class="rounded border bg-white" width="148" height="48" decoding="async" data-mct-loaded="0">
                                <button type="button" class="btn btn-sm btn-outline-secondary" id="membership-captcha-refresh" aria-label="โหลดรูปรหัสใหม่"><i class="ri-refresh-line align-middle me-1"></i>โหลดรูปใหม่</button>
                            </div>
                            <p id="membership-captcha-img-error" class="small text-danger fw-semibold mb-0 mt-2 d-none" role="status">ไม่สามารถแสดงรหัสภาพได้ (เซิร์ฟเวอร์อาจไม่พร้อม) กรุณากดโหลดรูปใหม่หรือรีเฟรชหน้า</p>
                        </div>
                        <div class="col-12 col-sm">
                            <input type="text" class="form-control" name="membership_captcha" id="membership_captcha" maxlength="5" minlength="5" autocomplete="off" autocapitalize="characters" spellcheck="false" inputmode="text" pattern="[A-Za-z0-9]{5}" placeholder="กรอกรหัส 5 ตัวตามภาพ (ตัวพิมพ์ใหญ่หรือเล็กได้)" required>
                            <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">กรุณากรอกรหัสภาพเพื่อความปลอดภัยให้ครบ 5 ตัว</small>
                            <small id="membership-captcha-format-hint" class="form-text mb-0 text-danger fw-bold d-none" role="status">กรุณากรอกเฉพาะตัวอักษร A–Z และตัวเลข 0–9 ตามภาพ (ไม่ใช้เว้นวรรคหรืออักขระอื่น)</small>
                            <small class="text-muted d-block mt-1">ใช้ป้องกันการส่งฟอร์มอัตโนมัติ หากอ่านไม่ชัดให้กดโหลดรูปใหม่</small>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mt-3">
                    <p class="text-muted small mb-0"><i class="ri-information-line align-middle me-1"></i>ส่งข้อมูลสมัครสมาชิก MCT Online เพื่อตรวจสอบก่อนอนุมัติการเป็นสมาชิก</p>
                    <div class="d-flex flex-wrap gap-2 align-items-center">
                        <button v-if="showFormTestTools" type="button" class="btn btn-soft-warning" id="btn-member-mock-fill"><i class="ri-magic-line align-middle me-1"></i>เติมข้อมูลจำลอง (Test)</button>
                        <button type="button" class="btn btn-soft-info" id="btn-preview-data"><i class="ri-eye-line align-middle me-1"></i>แสดงตัวอย่างข้อมูล</button>
                        <button type="reset" class="btn btn-soft-secondary"><i class="ri-arrow-go-back-line align-middle me-1"></i>ล้างข้อมูล</button>
                        <button type="submit" class="btn btn-primary" id="btn-member-add-submit"><i class="ri-send-plane-fill align-middle me-1"></i>ส่งใบสมัคร</button>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="modal fade" id="member-preview-modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"><i class="ri-eye-line align-middle me-2"></i>ตัวอย่างข้อมูลก่อนส่งใบสมัคร</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="preview-shell">
                        <div id="member-preview-content" class="preview-grid"></div>
                    </div>
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-soft-primary" id="btn-preview-pdf">ส่งออก PDF</button> -->
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal"><i class="ri-close-line align-middle me-1"></i>ปิด</button>
                </div>
            </div>
        </div>
    </div>

                    <div class="text-center text-white small py-3">
                        <i class="ri-copyright-line align-middle me-1"></i>Copyright © 2026 - Music Copyright (Thailand) Ltd.
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</div>
</div>
</div>
</div>
</template>

<script>
function runPublicApplication(config) {
    config = config || {};
    var mctAppFlashScrollTo = String(config.flashScrollTo || "");

    function mctFindControlForReqHint(hintEl) {
        if (hintEl.classList.contains("mct-req-hint-legend")) {
            return null;
        }
        var prev = hintEl.previousElementSibling;
        if (!prev) {
            return null;
        }
        if (prev.matches && (prev.matches("input") || prev.matches("select") || prev.matches("textarea"))) {
            return prev;
        }
        var nested = prev.querySelector && prev.querySelector("input[required], select[required], textarea[required], input, select, textarea");
        if (nested) {
            return nested;
        }
        var checkWrap = hintEl.closest ? hintEl.closest(".form-check") : null;
        if (checkWrap) {
            var checkInput = checkWrap.querySelector("input[required], input[type='checkbox'], input[type='radio']");
            if (checkInput) {
                return checkInput;
            }
        }
        return null;
    }

    function mctShouldShowReqHint(hintEl, formEl) {
        if (hintEl.classList.contains("mct-req-hint-legend")) {
            try {
                return !!formEl.querySelector(":invalid:not([disabled])");
            } catch (e) {
                return false;
            }
        }
        var ctl = mctFindControlForReqHint(hintEl);
        if (!ctl || ctl.disabled) {
            return false;
        }
        return !ctl.validity.valid;
    }

    function mctRefreshReqHints(formEl) {
        if (!formEl) {
            return;
        }
        if (!formEl.classList.contains("mct-submit-attempted")) {
            formEl.querySelectorAll(".mct-req-hint").forEach(function (h) {
                h.classList.add("d-none");
            });
            return;
        }
        formEl.querySelectorAll(".mct-req-hint").forEach(function (h) {
            if (mctShouldShowReqHint(h, formEl)) {
                h.classList.remove("d-none");
            } else {
                h.classList.add("d-none");
            }
        });
    }

    function mctDigitsOnly(str) {
        return String(str || "").replace(/\D/g, "");
    }

    function mctFormatMobile(value) {
        var d = mctDigitsOnly(value).slice(0, 10);
        if (d.length <= 3) {
            return d;
        }
        if (d.length <= 6) {
            return d.slice(0, 3) + " " + d.slice(3);
        }
        return d.slice(0, 3) + " " + d.slice(3, 6) + " " + d.slice(6);
    }

    function setupPhoneFormat() {
        var phone = document.getElementById("phone");
        if (!phone) {
            return;
        }
        phone.addEventListener("input", function () {
            phone.value = mctFormatMobile(phone.value);
        });
        phone.addEventListener("blur", function () {
            var d = mctDigitsOnly(phone.value);
            if (d.length > 0 && d.length !== 10) {
                phone.setCustomValidity("กรอกเบอร์มือถือให้ครบ 10 หลัก");
            } else if (!phone.classList.contains("is-duplicate")) {
                phone.setCustomValidity("");
            }
        });
        phone.addEventListener("focus", function () {
            if (!phone.classList.contains("is-duplicate")) {
                phone.setCustomValidity("");
            }
        });
    }

    var contactCheckUrl = String(config.contactCheckUrl || new URL("actions/member/check-application-membership-contact.php", window.location.href).href);
    var contactCheckAbort = null;
    var contactCheckTimer = null;

    function mctSetContactDuplicateState(fieldId, hintId, message) {
        var field = document.getElementById(fieldId);
        var hint = document.getElementById(hintId);
        if (!field) {
            return;
        }
        if (message) {
            field.classList.add("is-invalid", "is-duplicate");
            field.setCustomValidity(message);
            if (hint) {
                hint.textContent = message;
                hint.classList.remove("d-none");
            }
            return;
        }
        field.classList.remove("is-invalid", "is-duplicate");
        if (hint) {
            hint.textContent = "";
            hint.classList.add("d-none");
        }
        if (field.validity.customError) {
            field.setCustomValidity("");
        }
    }

    function mctApplyContactDuplicateFields(fields) {
        fields = fields || {};
        mctSetContactDuplicateState("email", "email-duplicate-hint", fields.email || "");
        mctSetContactDuplicateState("phone", "phone-duplicate-hint", fields.phone || "");
        mctSetContactDuplicateState("id_card", "id-card-duplicate-hint", fields.id_card || "");
    }

    function mctFirstDuplicateFieldEl(fields) {
        fields = fields || {};
        if (fields.email) {
            return document.getElementById("email");
        }
        if (fields.phone) {
            return document.getElementById("phone");
        }
        if (fields.id_card) {
            return document.getElementById("id_card");
        }
        return null;
    }

    function mctHasContactDuplicate() {
        return !!document.querySelector("#email.is-duplicate, #phone.is-duplicate, #id_card.is-duplicate");
    }

    function mctScheduleContactDuplicateCheck() {
        if (contactCheckTimer) {
            clearTimeout(contactCheckTimer);
        }
        contactCheckTimer = setTimeout(function () {
            contactCheckTimer = null;
            mctRunContactDuplicateCheck(false);
        }, 350);
    }

    function mctRunContactDuplicateCheck(forceShow) {
        var emailEl = document.getElementById("email");
        var phoneEl = document.getElementById("phone");
        var idCardEl = document.getElementById("id_card");
        if (!emailEl || !phoneEl || !idCardEl) {
            return Promise.resolve(false);
        }

        var email = String(emailEl.value || "").trim();
        var phone = String(phoneEl.value || "").trim();
        var idCard = String(idCardEl.value || "").trim();
        if (email === "" && phone === "" && idCard === "") {
            mctApplyContactDuplicateFields({});
            return Promise.resolve(false);
        }
        if (email !== "" && !emailEl.checkValidity()) {
            mctSetContactDuplicateState("email", "email-duplicate-hint", "");
            return Promise.resolve(false);
        }
        if (phone !== "" && mctDigitsOnly(phone).length > 0 && mctDigitsOnly(phone).length !== 10) {
            mctSetContactDuplicateState("phone", "phone-duplicate-hint", "");
            return Promise.resolve(false);
        }
        if (idCard !== "" && mctDigitsOnly(idCard).length > 0 && mctDigitsOnly(idCard).length !== 13) {
            mctSetContactDuplicateState("id_card", "id-card-duplicate-hint", "");
            return Promise.resolve(false);
        }

        if (contactCheckAbort) {
            contactCheckAbort.abort();
        }
        contactCheckAbort = new AbortController();

        var query = "email=" + encodeURIComponent(email)
            + "&phone=" + encodeURIComponent(phone)
            + "&id_card=" + encodeURIComponent(idCard);
        return fetch(contactCheckUrl + "?" + query, {
            signal: contactCheckAbort.signal,
            credentials: "same-origin",
        })
            .then(function (res) {
                return res.json().catch(function () {
                    return null;
                });
            })
            .then(function (data) {
                if (!data || data.ok !== true) {
                    return false;
                }
                mctApplyContactDuplicateFields(data.fields || {});
                if (forceShow && data.duplicate && data.message) {
                    var focusTarget = mctFirstDuplicateFieldEl(data.fields || {});
                    if (focusTarget) {
                        focusTarget.scrollIntoView({ behavior: "smooth", block: "center" });
                        focusTarget.focus();
                    }
                }
                return !!data.duplicate;
            })
            .catch(function (err) {
                if (err && err.name === "AbortError") {
                    return false;
                }
                return false;
            });
    }

    function setupContactDuplicateValidation() {
        var emailEl = document.getElementById("email");
        var phoneEl = document.getElementById("phone");
        var idCardEl = document.getElementById("id_card");
        if (!emailEl || !phoneEl || !idCardEl) {
            return;
        }

        emailEl.addEventListener("input", function () {
            mctSetContactDuplicateState("email", "email-duplicate-hint", "");
            mctScheduleContactDuplicateCheck();
        });
        phoneEl.addEventListener("input", function () {
            mctSetContactDuplicateState("phone", "phone-duplicate-hint", "");
            mctScheduleContactDuplicateCheck();
        });
        idCardEl.addEventListener("input", function () {
            mctSetContactDuplicateState("id_card", "id-card-duplicate-hint", "");
            mctScheduleContactDuplicateCheck();
        });
        emailEl.addEventListener("blur", function () {
            mctRunContactDuplicateCheck(false);
        });
        phoneEl.addEventListener("blur", function () {
            mctRunContactDuplicateCheck(false);
        });
        idCardEl.addEventListener("blur", function () {
            mctRunContactDuplicateCheck(false);
        });
    }

    function setupCreativeRoleRequired() {
        var roles = document.querySelectorAll(".mct-creative-role");
        if (!roles || roles.length === 0) {
            return;
        }
        function refreshRoleRequired() {
            var anyChecked = Array.prototype.some.call(roles, function (el) {
                return !!el.checked;
            });
            roles.forEach(function (el, idx) {
                if (idx === 0) {
                    el.required = !anyChecked;
                    if (!anyChecked) {
                        el.setCustomValidity("กรุณาเลือกอย่างน้อย 1 รายการ");
                    } else {
                        el.setCustomValidity("");
                    }
                } else {
                    el.required = false;
                    el.setCustomValidity("");
                }
            });
        }
        roles.forEach(function (el) {
            el.addEventListener("change", refreshRoleRequired);
        });
        refreshRoleRequired();
    }

    function getIdDocumentType() {
        var checked = document.querySelector('input[name="id_document_type"]:checked');
        return checked ? String(checked.value || "id_card") : "id_card";
    }

    function setupIdCardValidation() {
        var idCardInput = document.getElementById("id_card");
        var idCardLabel = document.getElementById("id-card-label");
        var idDocFileLabel = document.getElementById("id-document-file-label");
        var typeRadios = document.querySelectorAll('input[name="id_document_type"]');
        if (!idCardInput) {
            return;
        }
        var applyTypeUi = function () {
            var isPassport = getIdDocumentType() === "passport";
            if (idCardLabel) {
                idCardLabel.innerHTML = isPassport
                    ? 'เลขพาสปอร์ต <span class="text-danger">*</span>'
                    : 'เลขบัตรประชาชน (13 หลัก) <span class="text-danger">*</span>';
            }
            if (idDocFileLabel) {
                idDocFileLabel.innerHTML = isPassport
                    ? 'สำเนาพาสปอร์ต <span class="text-danger">*</span>'
                    : 'สำเนาบัตรประชาชน <span class="text-danger">*</span>';
            }
            if (isPassport) {
                idCardInput.setAttribute("inputmode", "text");
                idCardInput.setAttribute("pattern", "[A-Za-z0-9]{6,20}");
                idCardInput.setAttribute("minlength", "6");
                idCardInput.setAttribute("maxlength", "20");
                idCardInput.setAttribute("placeholder", "เช่น AA1234567");
            } else {
                idCardInput.setAttribute("inputmode", "numeric");
                idCardInput.setAttribute("pattern", "[0-9]{13}");
                idCardInput.setAttribute("minlength", "13");
                idCardInput.setAttribute("maxlength", "13");
                idCardInput.setAttribute("placeholder", "เช่น 1103700000000");
            }
        };
        var enforce = function () {
            var isPassport = getIdDocumentType() === "passport";
            if (isPassport) {
                var raw = String(idCardInput.value || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 20);
                idCardInput.value = raw;
                if (raw.length === 0) {
                    idCardInput.setCustomValidity("");
                    return;
                }
                if (raw.length < 6) {
                    idCardInput.setCustomValidity("เลขพาสปอร์ตต้องมีอย่างน้อย 6 ตัวอักษร");
                } else if (!idCardInput.classList.contains("is-duplicate")) {
                    idCardInput.setCustomValidity("");
                }
                return;
            }
            var digits = String(idCardInput.value || "").replace(/\D/g, "").slice(0, 13);
            idCardInput.value = digits;
            if (digits.length === 0) {
                idCardInput.setCustomValidity("");
                return;
            }
            if (digits.length !== 13) {
                idCardInput.setCustomValidity("เลขบัตรประชาชนต้องเป็นตัวเลข 13 หลัก");
            } else if (!idCardInput.classList.contains("is-duplicate")) {
                idCardInput.setCustomValidity("");
            }
        };
        typeRadios.forEach(function (el) {
            el.addEventListener("change", function () {
                applyTypeUi();
                enforce();
                mctSetContactDuplicateState("id_card", "id-card-duplicate-hint", "");
                mctScheduleContactDuplicateCheck();
            });
        });
        idCardInput.addEventListener("input", enforce);
        idCardInput.addEventListener("blur", enforce);
        applyTypeUi();
        enforce();
    }

    function setupOtherSpecifyField(selectId, otherId) {
        var selectEl = document.getElementById(selectId);
        var otherEl = document.getElementById(otherId);
        if (!selectEl || !otherEl) {
            return;
        }
        var refresh = function () {
            var isOther = String(selectEl.value || "") === "อื่นๆ";
            otherEl.classList.toggle("d-none", !isOther);
            otherEl.required = isOther;
            if (!isOther) {
                otherEl.value = "";
                otherEl.setCustomValidity("");
            }
        };
        selectEl.addEventListener("change", refresh);
        refresh();
    }

    function setupMailingAddressToggle() {
        var sameChk = document.getElementById("mailing-same-as-id");
        var wrap = document.getElementById("mailing-address-fields");
        if (!sameChk || !wrap) {
            return;
        }
        var fields = [
            document.getElementById("mailing_street"),
            document.getElementById("mailing-subdistrict"),
            document.getElementById("mailing-district"),
            document.getElementById("mailing-province"),
            document.getElementById("mailing-postal-code")
        ];
        var refresh = function () {
            var useSame = !!sameChk.checked;
            wrap.classList.toggle("d-none", useSame);
            fields.forEach(function (el) {
                if (!el) {
                    return;
                }
                el.required = !useSame;
                if (useSame) {
                    el.setCustomValidity("");
                }
            });
        };
        sameChk.addEventListener("change", refresh);
        refresh();
    }

    function setupBirthDateValidation() {
        var birthDateInput = document.getElementById("birth_date");
        var birthDatePickerBtn = document.getElementById("btn-birth-date-picker");
        var birthDatePicker = null;
        if (!birthDateInput) {
            return;
        }
        if (typeof window.flatpickr === "function") {
            birthDatePicker = window.flatpickr(birthDateInput, {
                dateFormat: "d/m/Y",
                allowInput: true,
                disableMobile: true
            });
        }
        var enforce = function () {
            var raw = String(birthDateInput.value || "");
            var digits = raw.replace(/\D/g, "").slice(0, 8);
            var formatted = digits;
            if (digits.length > 4) {
                formatted = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4);
            } else if (digits.length > 2) {
                formatted = digits.slice(0, 2) + "/" + digits.slice(2);
            }
            birthDateInput.value = formatted;
            if (formatted.length === 0) {
                birthDateInput.setCustomValidity("");
                return;
            }
            var m = formatted.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (!m) {
                birthDateInput.setCustomValidity("กรุณากรอกวันเดือนปีเกิดรูปแบบ dd/mm/yyyy");
                return;
            }
            var day = Number(m[1]);
            var month = Number(m[2]);
            var year = Number(m[3]);
            var d = new Date(year, month - 1, day);
            if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) {
                birthDateInput.setCustomValidity("วันเดือนปีเกิดไม่ถูกต้อง");
                return;
            }
            birthDateInput.setCustomValidity("");
        };
        birthDateInput.addEventListener("input", enforce);
        birthDateInput.addEventListener("blur", enforce);
        if (birthDatePickerBtn) {
            birthDatePickerBtn.addEventListener("click", function () {
                if (birthDatePicker && typeof birthDatePicker.open === "function") {
                    birthDatePicker.open();
                } else {
                    birthDateInput.focus();
                }
            });
        }
        enforce();
    }

    function escapeHtml(str) {
        var d = document.createElement("div");
        d.textContent = str == null ? "" : String(str);
        return d.innerHTML;
    }

    var form = document.getElementById("form-member-add");
    if (!form) {
        return;
    }
    var contractScrollBox = document.getElementById("contract-scroll-box");
    var acceptContract = document.getElementById("accept-contract");
    var acceptContractHint = document.getElementById("accept-contract-hint");
    var acceptContractReqHint = document.getElementById("accept-contract-req-hint");
    var gatedSections = document.querySelectorAll(".mct-public-application .mct-gated-section");
    var addressSearchUrl = String(config.addressSearchUrl || new URL("actions/thailand-address-search-public.php", window.location.href).href);
    var signatureCanvas = document.getElementById("signature-pad");
    var signatureDataInput = document.getElementById("signature-data");
    var signatureHint = document.getElementById("signature-hint");
    var signatureClearBtn = document.getElementById("btn-signature-clear");
    var penNameRows = document.getElementById("pen-name-rows");
    var addPenNameBtn = document.getElementById("btn-add-pen-name");
    var penNameHiddenInput = document.getElementById("pen_name");
    var oldNameInput = document.getElementById("old_name");
    var nameChangeDocInput = document.getElementById("name_change_document");
    var nameChangeDocHint = document.getElementById("name-change-doc-hint");
    var hasSignature = false;
    var signatureResizeFn = null;
    var mctGatedSectionsVisible = false;

    var captchaInlineMsgEl = document.getElementById("mct-membership-captcha-inline-msg");
    var formSubmitInlineMsgEl = document.getElementById("mct-form-submit-inline-msg");
    function mctShowFormSubmitError(text) {
        if (!formSubmitInlineMsgEl) {
            return;
        }
        formSubmitInlineMsgEl.textContent = String(text || "");
        formSubmitInlineMsgEl.classList.remove("d-none");
        formSubmitInlineMsgEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    function mctHideFormSubmitError() {
        if (!formSubmitInlineMsgEl) {
            return;
        }
        formSubmitInlineMsgEl.textContent = "";
        formSubmitInlineMsgEl.classList.add("d-none");
    }
    function mctShowCaptchaInlineMsg(text) {
        if (captchaInlineMsgEl) {
            captchaInlineMsgEl.textContent = String(text || "");
            captchaInlineMsgEl.classList.remove("d-none");
        }
    }

    var captchaImg = document.getElementById("membership-captcha-img");
    var captchaRefresh = document.getElementById("membership-captcha-refresh");
    var mctCaptchaReady = false;
    var mctCaptchaLoadSeq = 0;
    function mctIsCaptchaImageLoaded() {
        return !!(captchaImg && captchaImg.dataset.mctLoaded === "1" && mctCaptchaReady);
    }
    function mctReloadMembershipCaptcha() {
        if (!captchaImg) {
            return;
        }
        mctCaptchaReady = false;
        captchaImg.dataset.mctLoaded = "0";
        mctCaptchaLoadSeq += 1;
        var seq = mctCaptchaLoadSeq;
        captchaImg.setAttribute("data-mct-seq", String(seq));
        captchaImg.src = String(config.captchaImageUrl || new URL("actions/member/membership-captcha-image.php", window.location.href).href) + "?t=" + String(Date.now()) + "&s=" + String(seq);
    }
    function mctEnsureMembershipCaptchaLoaded() {
        if (!captchaImg) {
            return;
        }
        if (mctIsCaptchaImageLoaded()) {
            return;
        }
        // Avoid starting a second in-flight load (mobile race).
        if (captchaImg.getAttribute("src") && captchaImg.dataset.mctLoaded !== "1" && mctCaptchaLoadSeq > 0) {
            return;
        }
        mctReloadMembershipCaptcha();
    }
    if (captchaImg && captchaRefresh) {
        captchaRefresh.addEventListener("click", function () {
            var captchaField = document.getElementById("membership_captcha");
            if (captchaField) {
                captchaField.value = "";
                captchaField.classList.remove("is-invalid");
            }
            if (captchaInlineMsgEl) {
                captchaInlineMsgEl.textContent = "";
                captchaInlineMsgEl.classList.add("d-none");
            }
            mctReloadMembershipCaptcha();
        });
    }
    var captchaImgError = document.getElementById("membership-captcha-img-error");
    if (captchaImg && captchaImgError) {
        captchaImg.addEventListener("error", function () {
            var seq = String(captchaImg.getAttribute("data-mct-seq") || "");
            if (seq && seq !== String(mctCaptchaLoadSeq)) {
                return;
            }
            mctCaptchaReady = false;
            captchaImg.dataset.mctLoaded = "0";
            captchaImgError.classList.remove("d-none");
        });
        captchaImg.addEventListener("load", function () {
            var seq = String(captchaImg.getAttribute("data-mct-seq") || "");
            if (seq && seq !== String(mctCaptchaLoadSeq)) {
                return;
            }
            mctCaptchaReady = true;
            captchaImg.dataset.mctLoaded = "1";
            captchaImgError.classList.add("d-none");
        });
    }

    function setupMembershipCaptchaValidation() {
        var captchaInput = document.getElementById("membership_captcha");
        var formatHint = document.getElementById("membership-captcha-format-hint");
        if (!captchaInput) {
            return;
        }
        captchaInput.addEventListener("input", function () {
            captchaInput.classList.remove("is-invalid");
            var capMsg = document.getElementById("mct-membership-captcha-inline-msg");
            if (capMsg) {
                capMsg.textContent = "";
                capMsg.classList.add("d-none");
            }
            var before = String(captchaInput.value || "");
            var stripped = before.replace(/[^A-Za-z0-9]/g, "").slice(0, 5);
            if (before !== stripped && formatHint) {
                formatHint.classList.remove("d-none");
            }
            captchaInput.value = stripped;
            if (formatHint && stripped.length === 0) {
                formatHint.classList.add("d-none");
            } else if (formatHint && /^[A-Za-z0-9]{5}$/.test(stripped)) {
                formatHint.classList.add("d-none");
            }
            captchaInput.setCustomValidity("");
        });
        captchaInput.addEventListener("blur", function () {
            var v = String(captchaInput.value || "");
            if (v.length > 0 && v.length < 5) {
                captchaInput.setCustomValidity("กรุณากรอกรหัสภาพให้ครบ 5 ตัวตามภาพ");
            } else {
                captchaInput.setCustomValidity("");
            }
        });
        captchaInput.addEventListener("focus", function () {
            captchaInput.setCustomValidity("");
        });
        captchaInput.addEventListener("invalid", function () {
            if (captchaInput.validity.patternMismatch || captchaInput.validity.tooShort) {
                captchaInput.setCustomValidity("กรุณากรอกรหัส 5 ตัว ตัวอักษร A–Z และตัวเลข ตามภาพเท่านั้น");
            } else if (captchaInput.validity.valueMissing) {
                captchaInput.setCustomValidity("กรุณากรอกรหัสภาพเพื่อความปลอดภัย");
            }
        });
    }
    setupMembershipCaptchaValidation();

    setupPhoneFormat();
    setupContactDuplicateValidation();
    setupCreativeRoleRequired();
    setupIdCardValidation();
    setupBirthDateValidation();
    setupOtherSpecifyField("prefix", "prefix_other");
    setupOtherSpecifyField("bank_name", "bank_name_other");
    setupMailingAddressToggle();

    function getPenNames() {
        if (!penNameRows) {
            return [];
        }
        return Array.prototype.map.call(penNameRows.querySelectorAll(".mct-pen-name-item"), function (el) {
            return String(el.value || "").trim();
        }).filter(function (v) {
            return v !== "";
        });
    }

    function syncPenNameHiddenValue() {
        if (!penNameHiddenInput) {
            return;
        }
        penNameHiddenInput.value = getPenNames().join(", ");
    }

    function buildPenNameRow(value) {
        var row = document.createElement("div");
        row.className = "input-group mb-2 pen-name-row";
        row.innerHTML = ''
            + '<input type="text" class="form-control mct-pen-name-item" name="pen_names[]" placeholder="กรอกนามปากกา">'
            + '<button type="button" class="btn btn-soft-danger pen-name-remove" title="ลบรายการ"><i class="ri-delete-bin-line align-middle"></i> ลบ</button>';
        var input = row.querySelector(".mct-pen-name-item");
        if (input) {
            input.value = String(value || "");
        }
        return row;
    }

    function ensurePenNameRows() {
        if (!penNameRows) {
            return;
        }
        var rows = penNameRows.querySelectorAll(".pen-name-row");
        if (rows.length === 0) {
            penNameRows.appendChild(buildPenNameRow(""));
            rows = penNameRows.querySelectorAll(".pen-name-row");
        }
        Array.prototype.forEach.call(rows, function (row, idx) {
            var input = row.querySelector(".mct-pen-name-item");
            var removeBtn = row.querySelector(".pen-name-remove");
            if (input) {
                input.required = false;
            }
            if (removeBtn) {
                removeBtn.disabled = rows.length <= 1;
            }
        });
        syncPenNameHiddenValue();
    }

    function setPenNames(values) {
        if (!penNameRows) {
            return;
        }
        var normalized = Array.isArray(values) ? values.filter(function (v) {
            return String(v || "").trim() !== "";
        }) : [];
        if (normalized.length === 0) {
            normalized = [""];
        }
        penNameRows.innerHTML = "";
        normalized.forEach(function (v) {
            penNameRows.appendChild(buildPenNameRow(v));
        });
        ensurePenNameRows();
    }

    if (addPenNameBtn && penNameRows) {
        addPenNameBtn.addEventListener("click", function () {
            penNameRows.appendChild(buildPenNameRow(""));
            ensurePenNameRows();
        });
        penNameRows.addEventListener("click", function (event) {
            var target = event.target;
            if (!(target instanceof Element) || !target.classList.contains("pen-name-remove")) {
                return;
            }
            var row = target.closest(".pen-name-row");
            if (!row) {
                return;
            }
            row.remove();
            ensurePenNameRows();
        });
        penNameRows.addEventListener("input", function (event) {
            var target = event.target;
            if (target instanceof Element && target.classList.contains("mct-pen-name-item")) {
                syncPenNameHiddenValue();
            }
        });
        ensurePenNameRows();
    }

    function setupSignaturePad() {
        if (!signatureCanvas || !signatureDataInput) {
            return;
        }
        var ctx = signatureCanvas.getContext("2d");
        if (!ctx) {
            return;
        }
        var signaturePadWrap = signatureCanvas.closest(".signature-pad-wrap");
        var signatureResizeTimer = null;
        var signatureDisplayHeight = 180;

        function applyStrokeStyle() {
            var ratio = Math.max(window.devicePixelRatio || 1, 1);
            ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
            ctx.lineWidth = 2;
            ctx.lineCap = "round";
            ctx.lineJoin = "round";
            ctx.strokeStyle = "#212529";
        }

        function persistSignature() {
            if (!hasSignature) {
                return;
            }
            try {
                signatureDataInput.value = signatureCanvas.toDataURL("image/png");
            } catch (err) {
                /* ignore quota / security errors */
            }
        }

        function restoreSignatureFromData(dataUrl, displayWidth) {
            if (!dataUrl) {
                return;
            }
            var img = new Image();
            img.onload = function () {
                applyStrokeStyle();
                var drawWidth = displayWidth || signatureCanvas.getBoundingClientRect().width || signatureCanvas.width;
                ctx.clearRect(0, 0, signatureCanvas.width, signatureCanvas.height);
                ctx.drawImage(img, 0, 0, drawWidth, signatureDisplayHeight);
                hasSignature = true;
                signatureDataInput.value = dataUrl;
            };
            img.onerror = function () {
                hasSignature = false;
                signatureDataInput.value = "";
            };
            img.src = dataUrl;
        }

        function resizeCanvas() {
            var ratio = Math.max(window.devicePixelRatio || 1, 1);
            var rect = signatureCanvas.getBoundingClientRect();
            if (!rect.width || rect.width < 10) {
                return;
            }
            var savedData = (hasSignature || signatureDataInput.value) ? String(signatureDataInput.value || "") : "";
            var newWidth = Math.floor(rect.width * ratio);
            var newHeight = Math.floor(signatureDisplayHeight * ratio);
            if (signatureCanvas.width === newWidth && signatureCanvas.height === newHeight) {
                applyStrokeStyle();
                return;
            }
            signatureCanvas.width = newWidth;
            signatureCanvas.height = newHeight;
            applyStrokeStyle();
            if (savedData) {
                restoreSignatureFromData(savedData, rect.width);
            }
        }

        function scheduleSignatureResize() {
            if (signatureResizeTimer) {
                clearTimeout(signatureResizeTimer);
            }
            signatureResizeTimer = setTimeout(function () {
                signatureResizeTimer = null;
                resizeCanvas();
            }, 120);
        }

        signatureResizeFn = resizeCanvas;
        resizeCanvas();
        window.addEventListener("resize", scheduleSignatureResize);
        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", scheduleSignatureResize);
            window.visualViewport.addEventListener("scroll", scheduleSignatureResize);
        }
        if (typeof ResizeObserver === "function" && signaturePadWrap) {
            var padResizeObserver = new ResizeObserver(function () {
                scheduleSignatureResize();
            });
            padResizeObserver.observe(signaturePadWrap);
        }

        var drawing = false;
        function getPoint(e) {
            var rect = signatureCanvas.getBoundingClientRect();
            var t = (e.touches && e.touches[0]) ? e.touches[0] : ((e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : e);
            return { x: t.clientX - rect.left, y: t.clientY - rect.top };
        }
        function start(e) {
            drawing = true;
            applyStrokeStyle();
            var p = getPoint(e);
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            if (e.cancelable) {
                e.preventDefault();
            }
        }
        function move(e) {
            if (!drawing) {
                return;
            }
            applyStrokeStyle();
            var p = getPoint(e);
            ctx.lineTo(p.x, p.y);
            ctx.stroke();
            hasSignature = true;
            persistSignature();
            if (signatureHint) {
                signatureHint.classList.add("d-none");
            }
            if (e.cancelable) {
                e.preventDefault();
            }
        }
        function end(e) {
            if (drawing) {
                hasSignature = true;
                persistSignature();
            }
            drawing = false;
            if (e && e.cancelable) {
                e.preventDefault();
            }
        }

        signatureCanvas.addEventListener("mousedown", start);
        signatureCanvas.addEventListener("mousemove", move);
        signatureCanvas.addEventListener("mouseup", end);
        signatureCanvas.addEventListener("mouseleave", end);
        signatureCanvas.addEventListener("touchstart", start, { passive: false });
        signatureCanvas.addEventListener("touchmove", move, { passive: false });
        signatureCanvas.addEventListener("touchend", end, { passive: false });
        signatureCanvas.addEventListener("touchcancel", end, { passive: false });

        if (signatureClearBtn) {
            signatureClearBtn.addEventListener("click", function () {
                applyStrokeStyle();
                ctx.clearRect(0, 0, signatureCanvas.width, signatureCanvas.height);
                hasSignature = false;
                signatureDataInput.value = "";
            });
        }
    }
    setupSignaturePad();

    function bindThaiAddressLookup(cfg) {
        var input = document.getElementById(cfg.inputId);
        var dd = document.getElementById(cfg.dropdownId);
        var statusEl = document.getElementById(cfg.statusId);
        var errEl = document.getElementById(cfg.errorId);
        var fldSub = document.getElementById(cfg.subId);
        var fldDist = document.getElementById(cfg.distId);
        var fldProv = document.getElementById(cfg.provId);
        var fldZip = document.getElementById(cfg.zipId);
        if (!input || !dd || !fldSub || !fldDist || !fldProv || !fldZip) {
            return;
        }
        var timer = null;
        var abortCtl = null;
        function hideDropdown() {
            dd.style.display = "none";
            dd.innerHTML = "";
        }
        function setError(msg) {
            if (!errEl) {
                return;
            }
            if (msg) {
                errEl.style.display = "block";
                errEl.textContent = msg;
            } else {
                errEl.style.display = "none";
                errEl.textContent = "";
            }
        }
        input.addEventListener("input", function () {
            setError("");
            if (statusEl) {
                statusEl.textContent = "";
            }
            var q = String(input.value || "").trim();
            hideDropdown();
            if (timer) {
                clearTimeout(timer);
            }
            if (abortCtl) {
                abortCtl.abort();
                abortCtl = null;
            }
            if (q.length < 2) {
                return;
            }
            timer = setTimeout(function () {
                timer = null;
                if (abortCtl) {
                    abortCtl.abort();
                }
                abortCtl = new AbortController();
                if (statusEl) {
                    statusEl.textContent = "กำลังค้นหา...";
                }
                fetch(addressSearchUrl + "?q=" + encodeURIComponent(q) + "&limit=25", {
                    signal: abortCtl.signal,
                    credentials: "same-origin"
                })
                    .then(function (res) {
                        return res.json().catch(function () {
                            return null;
                        });
                    })
                    .then(function (data) {
                        if (statusEl) {
                            statusEl.textContent = "";
                        }
                        if (!data || !data.success) {
                            setError((data && data.message) ? data.message : "ไม่สามารถค้นหาที่อยู่ได้");
                            hideDropdown();
                            return;
                        }
                        var rows = data.results || [];
                        if (rows.length === 0) {
                            dd.innerHTML = '<span class="list-group-item text-muted">ไม่พบข้อมูลที่อยู่</span>';
                            dd.style.display = "block";
                            return;
                        }
                        var html = "";
                        rows.forEach(function (r, idx) {
                            var line = [r.subdistrict, r.district, r.province, r.postal_code].filter(Boolean).join(" > ");
                            html += '<button type="button" class="list-group-item list-group-item-action text-start" data-idx="' + idx + '">' + escapeHtml(line) + "</button>";
                        });
                        dd.innerHTML = html;
                        dd.__rows = rows;
                        dd.style.display = "block";
                    })
                    .catch(function (e) {
                        if (e && e.name === "AbortError") {
                            return;
                        }
                        if (statusEl) {
                            statusEl.textContent = "";
                        }
                        setError("ไม่สามารถเชื่อมต่อระบบค้นหาที่อยู่ได้");
                        hideDropdown();
                    });
            }, 280);
        });
        dd.addEventListener("click", function (e) {
            var btn = e.target && e.target.closest ? e.target.closest("button[data-idx]") : null;
            if (!btn || !dd.contains(btn)) {
                return;
            }
            var idx = parseInt(btn.getAttribute("data-idx"), 10);
            var rows = dd.__rows || [];
            var r = rows[idx];
            if (!r) {
                return;
            }
            fldSub.value = r.subdistrict || "";
            fldDist.value = r.district || "";
            fldProv.value = r.province || "";
            fldZip.value = r.postal_code || "";
            hideDropdown();
            setError("");
            if (statusEl) {
                statusEl.textContent = "";
            }
        });
        document.addEventListener("click", function (e) {
            var t = e.target;
            if ((input && input.contains(t)) || (dd && dd.contains(t))) {
                return;
            }
            hideDropdown();
        });
    }

    bindThaiAddressLookup({
        inputId: "address-live-search",
        dropdownId: "address-live-search-dropdown",
        statusId: "address-live-search-status",
        errorId: "address-live-search-error",
        subId: "address-subdistrict",
        distId: "address-district",
        provId: "address-province",
        zipId: "address-postal-code"
    });
    bindThaiAddressLookup({
        inputId: "mailing-live-search",
        dropdownId: "mailing-live-search-dropdown",
        statusId: "mailing-live-search-status",
        errorId: "mailing-live-search-error",
        subId: "mailing-subdistrict",
        distId: "mailing-district",
        provId: "mailing-province",
        zipId: "mailing-postal-code"
    });

    function setupSongRepeatable(containerId, addBtnId, inputName, placeholder) {
        var container = document.getElementById(containerId);
        var addBtn = document.getElementById(addBtnId);
        if (!container || !addBtn) {
            return;
        }
        function refreshRemoveButtons() {
            var rows = container.querySelectorAll(".song-repeat-row");
            var multi = rows.length > 1;
            rows.forEach(function (row) {
                var rm = row.querySelector(".song-row-remove");
                if (rm) {
                    rm.disabled = !multi;
                }
            });
        }
        addBtn.addEventListener("click", function () {
            var row = document.createElement("div");
            row.className = "input-group mb-2 song-repeat-row";
            row.innerHTML =
                '<input type="text" class="form-control" name="' + inputName + '" placeholder="' + placeholder + '">' +
                '<button type="button" class="btn btn-soft-danger song-row-remove" title="ลบรายการ"><i class="ri-delete-bin-line align-middle"></i> ลบ</button>';
            container.appendChild(row);
            refreshRemoveButtons();
        });
        container.addEventListener("click", function (e) {
            var btn = e.target && e.target.closest ? e.target.closest(".song-row-remove") : null;
            if (!btn || !container.contains(btn)) {
                return;
            }
            if (container.querySelectorAll(".song-repeat-row").length <= 1) {
                return;
            }
            var row = btn.closest(".song-repeat-row");
            if (row) {
                row.remove();
            }
            refreshRemoveButtons();
        });
        refreshRemoveButtons();
    }

    setupSongRepeatable("composer-rows", "btn-add-composer", "song_composer[]", "ชื่อผู้แต่งทำนอง");
    setupSongRepeatable("lyricist-rows", "btn-add-lyricist", "song_lyricist[]", "ชื่อผู้แต่งคำร้อง");
    setupSongRepeatable("arranger-rows", "btn-add-arranger", "song_arranger[]", "ชื่อผู้เรียบเรียง");

    function mctIsContractScrolledToEnd() {
        if (!contractScrollBox) {
            return false;
        }
        var clientH = contractScrollBox.clientHeight;
        var scrollH = contractScrollBox.scrollHeight;
        if (clientH < 8 || scrollH < 8) {
            return false;
        }
        return contractScrollBox.scrollTop + clientH >= scrollH - 8;
    }

    function mctRefreshContractAcceptanceState() {
        if (!acceptContract) {
            return;
        }
        var canAccept = mctIsContractScrolledToEnd();
        acceptContract.disabled = !canAccept;
        if (!canAccept) {
            acceptContract.checked = false;
        }
        if (acceptContractHint) {
            acceptContractHint.classList.toggle("text-success", canAccept);
            acceptContractHint.classList.toggle("text-muted", !canAccept);
            acceptContractHint.innerHTML = canAccept
                ? '<i class="ri-checkbox-circle-line align-middle me-1"></i>คุณสามารถติ๊กยอมรับสัญญาได้'
                : '<i class="ri-arrow-down-double-line align-middle me-1"></i>กรุณาเลื่อนอ่านข้อความสัญญาให้สุดก่อน จึงจะสามารถติ๊กยอมรับได้';
        }
        mctRefreshGatedSections();
    }

    function mctRefreshGatedSections() {
        var canShow = !!(acceptContract && acceptContract.checked && !acceptContract.disabled);
        gatedSections.forEach(function (section) {
            if (canShow) {
                section.classList.add("is-unlocked");
                section.style.display = "";
            } else {
                section.classList.remove("is-unlocked");
                section.style.display = "none";
            }
        });
        // Resize canvas when gated sections become visible (layout may change on mobile).
        if (canShow && !mctGatedSectionsVisible && typeof signatureResizeFn === "function") {
            setTimeout(function () {
                signatureResizeFn();
            }, 50);
            setTimeout(function () {
                signatureResizeFn();
            }, 300);
        }
        if (canShow) {
            mctEnsureMembershipCaptchaLoaded();
        }
        mctGatedSectionsVisible = canShow;
    }

    if (contractScrollBox) {
        contractScrollBox.addEventListener("scroll", function () {
            mctRefreshContractAcceptanceState();
        });
    }
    if (acceptContract) {
        acceptContract.addEventListener("change", function () {
            if (acceptContract.checked && acceptContractReqHint) {
                acceptContractReqHint.classList.add("d-none");
            }
            mctRefreshGatedSections();
        });
    }
    mctRefreshContractAcceptanceState();
    window.addEventListener("resize", mctRefreshContractAcceptanceState);
    var layoutTries = 0;
    function mctRetryContractLayout() {
        mctRefreshContractAcceptanceState();
        layoutTries += 1;
        if (layoutTries < 10 && contractScrollBox && contractScrollBox.scrollHeight < 8) {
            setTimeout(mctRetryContractLayout, 150);
        }
    }
    if (typeof requestAnimationFrame === "function") {
        requestAnimationFrame(function () {
            requestAnimationFrame(mctRetryContractLayout);
        });
    } else {
        setTimeout(mctRetryContractLayout, 0);
    }

    function mctValidateNameChangeDoc() {
        var hasOldName = oldNameInput && oldNameInput.value.trim() !== "";
        if (!hasOldName) {
            if (nameChangeDocHint) {
                nameChangeDocHint.classList.add("d-none");
            }
            if (nameChangeDocInput) {
                nameChangeDocInput.classList.remove("is-invalid");
            }
            return true;
        }
        var hasFile = nameChangeDocInput && nameChangeDocInput.files && nameChangeDocInput.files.length > 0;
        var ok = hasFile;
        if (nameChangeDocHint) {
            nameChangeDocHint.classList.toggle("d-none", ok);
        }
        if (nameChangeDocInput) {
            nameChangeDocInput.classList.toggle("is-invalid", !ok);
        }
        return ok;
    }

    function mctRefreshNameChangeDocState() {
        var hasOldName = oldNameInput && oldNameInput.value.trim() !== "";
        if (!nameChangeDocInput) {
            return;
        }
        nameChangeDocInput.disabled = !hasOldName;
        if (!hasOldName) {
            nameChangeDocInput.value = "";
        }
        mctValidateNameChangeDoc();
    }

    if (oldNameInput) {
        oldNameInput.addEventListener("input", mctRefreshNameChangeDocState);
    }
    if (nameChangeDocInput) {
        nameChangeDocInput.addEventListener("change", mctValidateNameChangeDoc);
    }
    mctRefreshNameChangeDocState();

    var previewBtn = document.getElementById("btn-preview-data");
    var previewContent = document.getElementById("member-preview-content");
    var previewModalEl = document.getElementById("member-preview-modal");
    var previewPdfBtn = document.getElementById("btn-preview-pdf");

    function getVal(id) {
        var el = document.getElementById(id);
        return el ? String(el.value || "").trim() : "";
    }

    function getRepeatVals(selector) {
        return Array.prototype.map.call(document.querySelectorAll(selector), function (el) {
            return String(el.value || "").trim();
        }).filter(function (v) {
            return v !== "";
        });
    }

    function rowsHtml(rows) {
        return rows.map(function (r) {
            return '<div class="preview-row"><span class="preview-label">' + escapeHtml(r.label) + '</span><span class="preview-value">' + escapeHtml(r.value || "-") + "</span></div>";
        }).join("");
    }

    function listHtml(values) {
        if (!values || values.length === 0) {
            return '<span class="preview-value">-</span>';
        }
        return "<ul class='preview-list'>" + values.map(function (v) {
            return "<li>" + escapeHtml(v) + "</li>";
        }).join("") + "</ul>";
    }

    function renderPreview() {
        if (!previewContent) {
            return "";
        }
        var roles = [];
        document.querySelectorAll(".mct-creative-role:checked").forEach(function (el) {
            var label = form.querySelector("label[for='" + el.id + "']");
            roles.push(label ? label.textContent.trim() : el.value);
        });

        var address = [getVal("address"), getVal("address-subdistrict"), getVal("address-district"), getVal("address-province"), getVal("address-postal-code")].filter(Boolean).join(" ");
        var signatureState = getVal("signature-data") ? "มีลายเซ็นแล้ว" : "ยังไม่มีลายเซ็น";
        var idDoc = document.getElementById("id_document");
        var idDocName = (idDoc && idDoc.files && idDoc.files[0]) ? idDoc.files[0].name : "-";
        var nameChangeDoc = document.getElementById("name_change_document");
        var nameChangeDocName = (nameChangeDoc && nameChangeDoc.files && nameChangeDoc.files[0]) ? nameChangeDoc.files[0].name : "-";
        var bankBookDoc = document.getElementById("bank_book_document");
        var bankBookDocName = (bankBookDoc && bankBookDoc.files && bankBookDoc.files[0]) ? bankBookDoc.files[0].name : "-";

        var mailingSame = document.getElementById("mailing-same-as-id");
        var mailingAddress = mailingSame && mailingSame.checked
            ? address
            : [getVal("mailing_street"), getVal("mailing-subdistrict"), getVal("mailing-district"), getVal("mailing-province"), getVal("mailing-postal-code")].filter(Boolean).join(" ");
        var prefixVal = getVal("prefix") === "อื่นๆ" ? getVal("prefix_other") : getVal("prefix");
        var bankVal = getVal("bank_name") === "อื่นๆ" ? getVal("bank_name_other") : getVal("bank_name");
        var idType = getIdDocumentType() === "passport" ? "พาสปอร์ต" : "บัตรประชาชน";

        var html = ""
            + '<div class="preview-card"><h6>ข้อมูลส่วนบุคคล</h6>'
            + rowsHtml([
                { label: "ชื่อ-นามสกุล (ไทย)", value: [prefixVal, getVal("first_name"), getVal("last_name")].filter(Boolean).join(" ") },
                { label: "ชื่อ-นามสกุล (English)", value: [getVal("first_name_en"), getVal("last_name_en")].filter(Boolean).join(" ") },
                { label: "สัญชาติ", value: getVal("nationality") },
                { label: "ประเภทเอกสาร", value: idType },
                { label: "เลขบัตร/พาสปอร์ต", value: getVal("id_card") },
                { label: "วันเดือนปีเกิด", value: getVal("birth_date") },
                { label: "นามปากกา", value: getPenNames().join(", ") },
                { label: "ชื่อ-สกุลเก่า", value: getVal("old_name") }
            ])
            + '<div class="preview-row"><span class="preview-label">ประเภทผู้สร้างสรรค์</span>' + listHtml(roles) + "</div>"
            + "</div>"
            + '<div class="preview-card"><h6>ข้อมูลติดต่อ</h6>'
            + rowsHtml([
                { label: "อีเมล", value: getVal("email") },
                { label: "เบอร์โทรศัพท์", value: getVal("phone") },
                { label: "Line ID", value: getVal("line_id") },
                { label: "Facebook/Social", value: getVal("facebook") }
            ])
            + "</div>"
            + '<div class="preview-card"><h6>ที่อยู่</h6>'
            + rowsHtml([
                { label: "ที่อยู่ตามทะเบียน", value: address },
                { label: "ที่อยู่จัดส่งเอกสาร", value: mailingAddress }
            ])
            + "</div>"
            + '<div class="preview-card"><h6>ผลงานเพลง</h6>'
            + rowsHtml([
                { label: "ชื่อเพลง", value: getVal("song_title") },
                { label: "ศิลปิน", value: getVal("song_artist") },
                { label: "อัลบั้ม", value: getVal("song_album") },
                { label: "เนื้อร้องขึ้นต้น", value: getVal("song_lyrics_opening") },
                { label: "พับลิชเชอร์", value: getVal("publisher") },
                { label: "URL เผยแพร่", value: getVal("song_publish_url") }
            ])
            + '<div class="preview-row"><span class="preview-label">ผู้แต่งทำนอง</span>' + listHtml(getRepeatVals('input[name="song_composer[]"]')) + "</div>"
            + '<div class="preview-row"><span class="preview-label">ผู้แต่งคำร้อง</span>' + listHtml(getRepeatVals('input[name="song_lyricist[]"]')) + "</div>"
            + '<div class="preview-row"><span class="preview-label">ผู้เรียบเรียง</span>' + listHtml(getRepeatVals('input[name="song_arranger[]"]')) + "</div>"
            + "</div>"
            + '<div class="preview-card"><h6>ข้อมูลบัญชีธนาคาร</h6>'
            + rowsHtml([
                { label: "ธนาคาร", value: bankVal },
                { label: "ชื่อบัญชี", value: getVal("bank_account_holder_name") },
                { label: "เลขที่บัญชีธนาคาร", value: getVal("bank_account_number") },
                { label: "ไฟล์หน้าสมุดบัญชี", value: bankBookDocName }
            ])
            + "</div>"
            + '<div class="preview-card"><h6>เอกสารและลายเซ็น</h6>'
            + rowsHtml([
                { label: "สำเนาบัตรประชาชน/พาสปอร์ต", value: idDocName },
                { label: "เอกสารยืนยันการเปลี่ยนชื่อ", value: nameChangeDocName },
                { label: "สถานะลายเซ็น", value: signatureState }
            ])
            + "</div>";

        previewContent.innerHTML = html;
        return html;
    }

    if (previewBtn && previewContent && previewModalEl) {
        previewBtn.addEventListener("click", function () {
            renderPreview();
            if (window.bootstrap && window.bootstrap.Modal) {
                var modal = window.bootstrap.Modal.getOrCreateInstance(previewModalEl);
                modal.show();
            }
        });
    }

    if (previewPdfBtn && previewContent) {
        previewPdfBtn.addEventListener("click", function () {
            var contentHtml = renderPreview() || "<div>ยังไม่มีข้อมูลสำหรับแสดงตัวอย่าง</div>";
            var w = window.open("", "_blank");
            if (!w) {
                return;
            }
            w.document.write(
                "<!doctype html><html><head><meta charset='utf-8'><title>Preview Application PDF</title>" +
                "<style>body{font-family:Tahoma,Arial,sans-serif;padding:24px;line-height:1.5;color:#212529}h1{font-size:20px;margin:0 0 16px}.preview-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}.preview-card{border:1px solid #e9ebec;border-radius:8px;padding:12px;background:#fff}.preview-card h6{margin:0 0 10px;color:#495057}.preview-row{margin-bottom:6px;font-size:13px}.preview-label{display:inline-block;min-width:140px;color:#6c757d}.preview-value{font-weight:600}ul{margin:0;padding-left:18px}</style>" +
                "</head><body><h1>ตัวอย่างข้อมูลก่อนส่งใบสมัคร</h1><div class='preview-grid'>" + contentHtml + "</div></body></html>"
            );
            w.document.close();
            w.focus();
            setTimeout(function () {
                w.print();
            }, 250);
        });
    }

    var mockFillBtn = document.getElementById("btn-member-mock-fill");
    if (mockFillBtn) {
        mockFillBtn.addEventListener("click", function () {
            var now = Date.now();
            var emailSeed = String(now).slice(-6);

            var setVal = function (id, value) {
                var el = document.getElementById(id);
                if (el) {
                    el.value = value;
                    el.dispatchEvent(new Event("input", { bubbles: true }));
                    el.dispatchEvent(new Event("change", { bubbles: true }));
                }
            };

            setVal("prefix", "นาย");
            setVal("nationality", "ไทย");
            setVal("first_name", "ทดสอบ");
            setVal("last_name", "ระบบ");
            setVal("first_name_en", "Test");
            setVal("last_name_en", "System");
            setVal("id_card", "1103700000000");
            setVal("birth_date", "15/01/1995");
            setPenNames(["นามปากกาทดสอบ", "นามปากกาสำรอง"]);
            setVal("old_name", "ชื่อเก่า นามสกุลเก่า");

            setVal("email", "test" + emailSeed + "@example.com");
            setVal("phone", "081 234 5678");
            setVal("line_id", "testline" + emailSeed);
            setVal("facebook", "facebook.com/test.profile");

            setVal("address", "99/9 อาคารทดสอบ ซอยทดสอบ ถนนตัวอย่าง");
            setVal("address-live-search", "ปทุมวัน กรุงเทพมหานคร");
            setVal("address-subdistrict", "ลุมพินี");
            setVal("address-district", "ปทุมวัน");
            setVal("address-province", "กรุงเทพมหานคร");
            setVal("address-postal-code", "10330");

            setVal("song_title", "เพลงทดสอบระบบ");
            setVal("song_artist", "ศิลปินทดสอบ");
            setVal("song_album", "อัลบั้มทดสอบ");
            setVal("song_lyrics_opening", "ทดสอบเนื้อร้องขึ้นต้นในระบบ");
            setVal("publisher", "Test Publisher Co.,Ltd.");
            setVal("song_publish_url", "https://youtube.com/watch?v=dQw4w9WgXcQ");

            setVal("bank_name", "ธนาคารกสิกรไทย");
            setVal("bank_account_holder_name", "นาย ทดสอบ ระบบ");
            setVal("bank_account_number", "123-4-56789-0");

            var setFirstRepeat = function (selector, value) {
                var el = document.querySelector(selector);
                if (el) {
                    el.value = value;
                    el.dispatchEvent(new Event("input", { bubbles: true }));
                    el.dispatchEvent(new Event("change", { bubbles: true }));
                }
            };
            setFirstRepeat('input[name="song_composer[]"]', "ผู้แต่งทำนองทดสอบ");
            setFirstRepeat('input[name="song_lyricist[]"]', "ผู้แต่งคำร้องทดสอบ");
            setFirstRepeat('input[name="song_arranger[]"]', "ผู้เรียบเรียงทดสอบ");

            var roleComposer = document.getElementById("creative-role-composer");
            var roleAuthor = document.getElementById("creative-role-author");
            if (roleComposer) {
                roleComposer.checked = true;
                roleComposer.dispatchEvent(new Event("change", { bubbles: true }));
            }
            if (roleAuthor) {
                roleAuthor.checked = true;
                roleAuthor.dispatchEvent(new Event("change", { bubbles: true }));
            }
        });
    }

    function mctReadFileAsDataUrl(file) {
        return new Promise(function (resolve, reject) {
            if (!file) {
                resolve("");
                return;
            }
            var reader = new FileReader();
            reader.onload = function () {
                resolve(String(reader.result || ""));
            };
            reader.onerror = function () {
                reject(new Error("read_file_failed"));
            };
            reader.readAsDataURL(file);
        });
    }

    function mctCompressImageFile(file) {
        return new Promise(function (resolve) {
            if (!file || !file.type || !/^image\/(jpeg|jpg|png|webp)$/i.test(file.type)) {
                resolve(file);
                return;
            }
            // Skip tiny files; compress large mobile camera photos.
            if (file.size < 900 * 1024) {
                resolve(file);
                return;
            }
            var url = URL.createObjectURL(file);
            var img = new Image();
            img.onload = function () {
                URL.revokeObjectURL(url);
                var maxDim = 1600;
                var w = img.naturalWidth || img.width;
                var h = img.naturalHeight || img.height;
                if (!w || !h) {
                    resolve(file);
                    return;
                }
                var scale = Math.min(1, maxDim / Math.max(w, h));
                var cw = Math.max(1, Math.round(w * scale));
                var ch = Math.max(1, Math.round(h * scale));
                var canvas = document.createElement("canvas");
                canvas.width = cw;
                canvas.height = ch;
                var ctx = canvas.getContext("2d");
                if (!ctx) {
                    resolve(file);
                    return;
                }
                ctx.drawImage(img, 0, 0, cw, ch);
                canvas.toBlob(function (blob) {
                    if (!blob || blob.size <= 0) {
                        resolve(file);
                        return;
                    }
                    var outName = String(file.name || "photo.jpg").replace(/\.\w+$/, "") + ".jpg";
                    try {
                        resolve(new File([blob], outName, { type: "image/jpeg", lastModified: Date.now() }));
                    } catch (e) {
                        resolve(blob);
                    }
                }, "image/jpeg", 0.82);
            };
            img.onerror = function () {
                URL.revokeObjectURL(url);
                resolve(file);
            };
            img.src = url;
        });
    }

    function mctAttachFileAsBase64(fd, fieldName) {
        var fileInput = document.getElementById(fieldName);
        var file = (fileInput && fileInput.files && fileInput.files[0]) ? fileInput.files[0] : null;
        if (!file) {
            return Promise.resolve(fd);
        }
        return mctCompressImageFile(file).then(function (readyFile) {
            return mctReadFileAsDataUrl(readyFile).then(function (base64) {
                var outName = (readyFile && readyFile.name) ? readyFile.name : (file.name || (fieldName + ".png"));
                fd.append(fieldName + "_name", outName);
                fd.append(fieldName + "_base64", base64);
                fd.delete(fieldName);
                return fd;
            });
        });
    }

    function mctBuildSubmitFormData() {
        var fd = new FormData(form);
        // Explicitly set captcha — mobile Safari can drop fields when multipart payload is large.
        var captchaField = document.getElementById("membership_captcha");
        var captchaVal = captchaField
            ? String(captchaField.value || "").replace(/[^A-Za-z0-9]/g, "").slice(0, 5)
            : "";
        fd.set("membership_captcha", captchaVal);
        return mctAttachFileAsBase64(fd, "id_document")
            .then(function (nextFd) {
                return mctAttachFileAsBase64(nextFd, "name_change_document");
            })
            .then(function (nextFd) {
                return mctAttachFileAsBase64(nextFd, "bank_book_document");
            })
            .then(function (nextFd) {
                // Re-set after file transforms in case of browser FormData quirks.
                nextFd.set("membership_captcha", captchaVal);
                return nextFd;
            });
    }

    form.addEventListener("submit", function (event) {
        syncPenNameHiddenValue();
        form.classList.add("mct-submit-attempted");
        mctRefreshReqHints(form);
        if (acceptContractReqHint) {
            acceptContractReqHint.classList.add("d-none");
        }
        var contractAccepted = !acceptContract || (acceptContract.checked && !acceptContract.disabled);
        if (!contractAccepted && acceptContractReqHint) {
            acceptContractReqHint.classList.remove("d-none");
        }
        if (signatureHint) {
            signatureHint.classList.add("d-none");
        }
        if (!hasSignature && signatureHint) {
            signatureHint.classList.remove("d-none");
        }
        if (!mctValidateNameChangeDoc()) {
            event.preventDefault();
            event.stopPropagation();
            if (oldNameInput) {
                oldNameInput.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }
        if (!form.checkValidity() || !contractAccepted || !hasSignature || mctHasContactDuplicate()) {
            event.preventDefault();
            event.stopPropagation();
            if (mctHasContactDuplicate()) {
                mctRunContactDuplicateCheck(true);
            }
            return;
        }
        if (!mctIsCaptchaImageLoaded()) {
            event.preventDefault();
            event.stopPropagation();
            mctEnsureMembershipCaptchaLoaded();
            mctShowCaptchaInlineMsg("กรุณารอให้รหัสภาพโหลดเสร็จ หรือกดโหลดรูปใหม่ แล้วกรอกรหัสอีกครั้ง");
            var blockWait = document.getElementById("mct-membership-captcha-block");
            if (blockWait) {
                blockWait.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }
        var captchaPrecheck = document.getElementById("membership_captcha");
        var captchaPreVal = captchaPrecheck
            ? String(captchaPrecheck.value || "").replace(/[^A-Za-z0-9]/g, "").slice(0, 5)
            : "";
        if (captchaPreVal.length !== 5) {
            event.preventDefault();
            event.stopPropagation();
            mctShowCaptchaInlineMsg("กรุณากรอกรหัสภาพเพื่อความปลอดภัยให้ครบ 5 ตัว");
            if (captchaPrecheck) {
                captchaPrecheck.classList.add("is-invalid");
                captchaPrecheck.focus();
            }
            var blockCap = document.getElementById("mct-membership-captcha-block");
            if (blockCap) {
                blockCap.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        mctHideFormSubmitError();

        var submitBtn = document.getElementById("btn-member-add-submit");
        var prevDisabled = submitBtn ? submitBtn.disabled : false;
        if (submitBtn) {
            submitBtn.disabled = true;
        }

        mctRunContactDuplicateCheck(false).then(function (hasDuplicate) {
            if (hasDuplicate) {
                if (submitBtn) {
                    submitBtn.disabled = prevDisabled;
                }
                form.classList.add("mct-submit-attempted");
                mctRefreshReqHints(form);
                return;
            }

            mctBuildSubmitFormData().then(function (fd) {
                if (!fd.get("membership_captcha")) {
                    fd.set("membership_captcha", captchaPreVal);
                }
                return fetch(form.action, {
                    method: "POST",
                    body: fd,
                    credentials: "same-origin",
                    headers: { "X-Requested-With": "XMLHttpRequest" },
                    redirect: "manual"
                });
            }).then(function (resp) {
                var ct = (resp.headers.get("Content-Type") || "").toLowerCase();
                if (ct.indexOf("application/json") !== -1) {
                    return resp.json().then(function (data) {
                        if (submitBtn) {
                            submitBtn.disabled = prevDisabled;
                        }
                        if (data && data.ok === false && data.error === "payload_too_large" && data.message) {
                            mctShowFormSubmitError(data.message);
                            return;
                        }
                        if (data && data.ok === false && data.error === "captcha" && data.message) {
                            mctShowCaptchaInlineMsg(data.message);
                            var captchaField = document.getElementById("membership_captcha");
                            if (captchaField) {
                                captchaField.value = "";
                                captchaField.classList.add("is-invalid");
                            }
                            mctReloadMembershipCaptcha();
                            var block = document.getElementById("mct-membership-captcha-block");
                            if (block) {
                                block.scrollIntoView({ behavior: "smooth", block: "center" });
                            }
                            if (captchaField) {
                                captchaField.focus();
                            }
                            return;
                        }
                        if (data && data.ok === false && data.error === "duplicate_contact") {
                            mctApplyContactDuplicateFields(data.fields || {});
                            var dupTarget = mctFirstDuplicateFieldEl(data.fields || {});
                            if (dupTarget) {
                                dupTarget.scrollIntoView({ behavior: "smooth", block: "center" });
                                dupTarget.focus();
                            }
                            return;
                        }
                        if (data && data.ok === false && data.message) {
                            mctShowFormSubmitError(data.message);
                            return;
                        }
                        window.location.reload();
                    }).catch(function () {
                        if (submitBtn) {
                            submitBtn.disabled = prevDisabled;
                        }
                        window.location.reload();
                    });
                }
                if (submitBtn) {
                    submitBtn.disabled = prevDisabled;
                }
                if (resp.status === 301 || resp.status === 302 || resp.status === 303 || resp.status === 307 || resp.status === 308) {
                    var loc = resp.headers.get("Location");
                    if (loc) {
                        window.location.href = new URL(loc, form.action).href;
                    } else {
                        window.location.reload();
                    }
                    return;
                }
                window.location.reload();
            }).catch(function () {
                if (submitBtn) {
                    submitBtn.disabled = prevDisabled;
                }
                mctShowFormSubmitError("ไม่สามารถส่งใบสมัครได้ กรุณาตรวจสอบการเชื่อมต่อหรือลดขนาดไฟล์แนบแล้วลองใหม่");
            });
        });
    });

    form.addEventListener("input", function () {
        if (form.classList.contains("mct-submit-attempted")) {
            mctRefreshReqHints(form);
        }
    });

    form.addEventListener("change", function () {
        if (form.classList.contains("mct-submit-attempted")) {
            mctRefreshReqHints(form);
        }
        if (acceptContract && acceptContract.checked && acceptContractReqHint) {
            acceptContractReqHint.classList.add("d-none");
        }
        mctRefreshGatedSections();
    });

    form.addEventListener("reset", function () {
        setTimeout(function () {
            hasSignature = false;
            if (signatureDataInput) {
                signatureDataInput.value = "";
            }
            if (typeof signatureResizeFn === "function") {
                signatureResizeFn();
            }
            setPenNames([""]);
            mctReloadMembershipCaptcha();
            var fmtHint = document.getElementById("membership-captcha-format-hint");
            if (fmtHint) {
                fmtHint.classList.add("d-none");
            }
            if (form.classList.contains("mct-submit-attempted")) {
                mctRefreshReqHints(form);
            }
        }, 0);
    });

    if (typeof mctAppFlashScrollTo === "string" && mctAppFlashScrollTo !== "") {
        var scrollTarget = document.getElementById(mctAppFlashScrollTo);
        if (scrollTarget) {
            scrollTarget.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        // Do NOT reload captcha here — a second image request races the first on mobile
        // and leaves the visible code out of sync with the server token.
        var captchaField = document.getElementById("membership_captcha");
        if (captchaField) {
            captchaField.classList.add("is-invalid");
            setTimeout(function () {
                captchaField.focus();
            }, 400);
        }
    }
}

export default {
  name: "PublicApplication",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    isSubmittedSuccess: function () {
      return !!(this.config && this.config.isSubmittedSuccess);
    },
    showFormTestTools: function () {
      return !!(this.config && this.config.showFormTestTools);
    },
    flashMessage: function () {
      var flash = this.config && this.config.flash;
      return flash && flash.message ? String(flash.message) : "";
    },
    flashKind: function () {
      var flash = this.config && this.config.flash;
      return flash && flash.kind === "success" ? "success" : "danger";
    },
    captchaBlockMessage: function () {
      return String((this.config && this.config.captchaBlockMessage) || "");
    },
    bankOptions: function () {
      var raw = (this.config && this.config.bankOptions) || [];
      return Array.isArray(raw) ? raw : [];
    },
    createUrl: function () {
      return String((this.config && this.config.createUrl) || "actions/member/create-application-membership.php");
    },
    logoSrc: function () {
      var base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/assets/images/MCT-logo+LTD.colors-white.png";
    },
  },
  mounted: function () {
    runPublicApplication(this.config || {});
  },
};
</script>

<style>
.mct-gated-section {
  display: none !important;
}
.mct-gated-section.is-unlocked {
  display: flex !important;
}
.mct-public-application .card-title i,
.mct-public-application .mct-custom-topbar-title i {
  vertical-align: -2px;
}
.mct-contract-text {
  text-align: justify;
  line-height: 1.75;
  color: #212529;
}
.mct-contract-text p {
  margin-bottom: 0.7rem;
}
.mct-contract-text .mct-contract-title {
  text-align: center;
  font-weight: 700;
  font-size: 0.98rem;
  line-height: 1.45;
  margin: 0 0 0.85rem;
}
.mct-contract-text .mct-contract-lead {
  font-weight: 600;
  text-align: left;
  margin-bottom: 1rem;
}
.mct-contract-text .mct-article {
  font-weight: 700;
  text-align: left;
  margin: 1.05rem 0 0.4rem;
}
.mct-contract-text .mct-clause {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.7rem;
}
.mct-contract-text .mct-num {
  flex: 0 0 2.15rem;
  font-weight: 600;
}
.mct-contract-text ul {
  margin: 0.15rem 0 0.75rem 2.65rem;
  padding: 0;
}
.mct-contract-text li {
  margin-bottom: 0.35rem;
}
.mct-contract-text .mct-contract-divider {
  margin: 1.15rem 0;
  opacity: 0.35;
}
.mct-contract-text .mct-annex-kicker,
.mct-contract-text .mct-annex-title {
  text-align: center;
  font-weight: 700;
  margin-bottom: 0.4rem;
}
</style>
